exports.nonIcannPublicSuffixes = {
  "cc.ua": 1,
  "inf.ua": 1,
  "ltd.ua": 1,
  "611.to": 1,
  "graphox.us": 1,
  "devcdnaccesso.com": 2,
  "on-acorn.io": 2,
  "activetrail.biz": 1,
  "adobeaemcloud.com": 1,
  "dev.adobeaemcloud.com": 2,
  "hlx.live": 1,
  "adobeaemcloud.net": 1,
  "hlx.page": 1,
  "hlx3.page": 1,
  "adobeio-static.net": 1,
  "adobeioruntime.net": 1,
  "beep.pl": 1,
  "airkitapps.com": 1,
  "airkitapps-au.com": 1,
  "airkitapps.eu": 1,
  "aivencloud.com": 1,
  "akadns.net": 1,
  "akamai.net": 1,
  "akamai-staging.net": 1,
  "akamaiedge.net": 1,
  "akamaiedge-staging.net": 1,
  "akamaihd.net": 1,
  "akamaihd-staging.net": 1,
  "akamaiorigin.net": 1,
  "akamaiorigin-staging.net": 1,
  "akamaized.net": 1,
  "akamaized-staging.net": 1,
  "edgekey.net": 1,
  "edgekey-staging.net": 1,
  "edgesuite.net": 1,
  "edgesuite-staging.net": 1,
  "barsy.ca": 1,
  "compute.estate": 2,
  "alces.network": 2,
  "kasserver.com": 1,
  "altervista.org": 1,
  "alwaysdata.net": 1,
  "myamaze.net": 1,
  "execute-api.cn-north-1.amazonaws.com.cn": 1,
  "execute-api.cn-northwest-1.amazonaws.com.cn": 1,
  "execute-api.af-south-1.amazonaws.com": 1,
  "execute-api.ap-east-1.amazonaws.com": 1,
  "execute-api.ap-northeast-1.amazonaws.com": 1,
  "execute-api.ap-northeast-2.amazonaws.com": 1,
  "execute-api.ap-northeast-3.amazonaws.com": 1,
  "execute-api.ap-south-1.amazonaws.com": 1,
  "execute-api.ap-south-2.amazonaws.com": 1,
  "execute-api.ap-southeast-1.amazonaws.com": 1,
  "execute-api.ap-southeast-2.amazonaws.com": 1,
  "execute-api.ap-southeast-3.amazonaws.com": 1,
  "execute-api.ap-southeast-4.amazonaws.com": 1,
  "execute-api.ca-central-1.amazonaws.com": 1,
  "execute-api.eu-central-1.amazonaws.com": 1,
  "execute-api.eu-central-2.amazonaws.com": 1,
  "execute-api.eu-north-1.amazonaws.com": 1,
  "execute-api.eu-south-1.amazonaws.com": 1,
  "execute-api.eu-south-2.amazonaws.com": 1,
  "execute-api.eu-west-1.amazonaws.com": 1,
  "execute-api.eu-west-2.amazonaws.com": 1,
  "execute-api.eu-west-3.amazonaws.com": 1,
  "execute-api.il-central-1.amazonaws.com": 1,
  "execute-api.me-central-1.amazonaws.com": 1,
  "execute-api.me-south-1.amazonaws.com": 1,
  "execute-api.sa-east-1.amazonaws.com": 1,
  "execute-api.us-east-1.amazonaws.com": 1,
  "execute-api.us-east-2.amazonaws.com": 1,
  "execute-api.us-gov-east-1.amazonaws.com": 1,
  "execute-api.us-gov-west-1.amazonaws.com": 1,
  "execute-api.us-west-1.amazonaws.com": 1,
  "execute-api.us-west-2.amazonaws.com": 1,
  "cloudfront.net": 1,
  "auth.af-south-1.amazoncognito.com": 1,
  "auth.ap-northeast-1.amazoncognito.com": 1,
  "auth.ap-northeast-2.amazoncognito.com": 1,
  "auth.ap-northeast-3.amazoncognito.com": 1,
  "auth.ap-south-1.amazoncognito.com": 1,
  "auth.ap-southeast-1.amazoncognito.com": 1,
  "auth.ap-southeast-2.amazoncognito.com": 1,
  "auth.ap-southeast-3.amazoncognito.com": 1,
  "auth.ca-central-1.amazoncognito.com": 1,
  "auth.eu-central-1.amazoncognito.com": 1,
  "auth.eu-north-1.amazoncognito.com": 1,
  "auth.eu-south-1.amazoncognito.com": 1,
  "auth.eu-west-1.amazoncognito.com": 1,
  "auth.eu-west-2.amazoncognito.com": 1,
  "auth.eu-west-3.amazoncognito.com": 1,
  "auth.il-central-1.amazoncognito.com": 1,
  "auth.me-south-1.amazoncognito.com": 1,
  "auth.sa-east-1.amazoncognito.com": 1,
  "auth.us-east-1.amazoncognito.com": 1,
  "auth-fips.us-east-1.amazoncognito.com": 1,
  "auth.us-east-2.amazoncognito.com": 1,
  "auth-fips.us-east-2.amazoncognito.com": 1,
  "auth-fips.us-gov-west-1.amazoncognito.com": 1,
  "auth.us-west-1.amazoncognito.com": 1,
  "auth-fips.us-west-1.amazoncognito.com": 1,
  "auth.us-west-2.amazoncognito.com": 1,
  "auth-fips.us-west-2.amazoncognito.com": 1,
  "compute.amazonaws.com": 2,
  "compute-1.amazonaws.com": 2,
  "compute.amazonaws.com.cn": 2,
  "us-east-1.amazonaws.com": 1,
  "emrappui-prod.cn-north-1.amazonaws.com.cn": 1,
  "emrnotebooks-prod.cn-north-1.amazonaws.com.cn": 1,
  "emrstudio-prod.cn-north-1.amazonaws.com.cn": 1,
  "emrappui-prod.cn-northwest-1.amazonaws.com.cn": 1,
  "emrnotebooks-prod.cn-northwest-1.amazonaws.com.cn": 1,
  "emrstudio-prod.cn-northwest-1.amazonaws.com.cn": 1,
  "emrappui-prod.af-south-1.amazonaws.com": 1,
  "emrnotebooks-prod.af-south-1.amazonaws.com": 1,
  "emrstudio-prod.af-south-1.amazonaws.com": 1,
  "emrappui-prod.ap-east-1.amazonaws.com": 1,
  "emrnotebooks-prod.ap-east-1.amazonaws.com": 1,
  "emrstudio-prod.ap-east-1.amazonaws.com": 1,
  "emrappui-prod.ap-northeast-1.amazonaws.com": 1,
  "emrnotebooks-prod.ap-northeast-1.amazonaws.com": 1,
  "emrstudio-prod.ap-northeast-1.amazonaws.com": 1,
  "emrappui-prod.ap-northeast-2.amazonaws.com": 1,
  "emrnotebooks-prod.ap-northeast-2.amazonaws.com": 1,
  "emrstudio-prod.ap-northeast-2.amazonaws.com": 1,
  "emrappui-prod.ap-northeast-3.amazonaws.com": 1,
  "emrnotebooks-prod.ap-northeast-3.amazonaws.com": 1,
  "emrstudio-prod.ap-northeast-3.amazonaws.com": 1,
  "emrappui-prod.ap-south-1.amazonaws.com": 1,
  "emrnotebooks-prod.ap-south-1.amazonaws.com": 1,
  "emrstudio-prod.ap-south-1.amazonaws.com": 1,
  "emrappui-prod.ap-southeast-1.amazonaws.com": 1,
  "emrnotebooks-prod.ap-southeast-1.amazonaws.com": 1,
  "emrstudio-prod.ap-southeast-1.amazonaws.com": 1,
  "emrappui-prod.ap-southeast-2.amazonaws.com": 1,
  "emrnotebooks-prod.ap-southeast-2.amazonaws.com": 1,
  "emrstudio-prod.ap-southeast-2.amazonaws.com": 1,
  "emrappui-prod.ap-southeast-3.amazonaws.com": 1,
  "emrnotebooks-prod.ap-southeast-3.amazonaws.com": 1,
  "emrstudio-prod.ap-southeast-3.amazonaws.com": 1,
  "emrappui-prod.ca-central-1.amazonaws.com": 1,
  "emrnotebooks-prod.ca-central-1.amazonaws.com": 1,
  "emrstudio-prod.ca-central-1.amazonaws.com": 1,
  "emrappui-prod.eu-central-1.amazonaws.com": 1,
  "emrnotebooks-prod.eu-central-1.amazonaws.com": 1,
  "emrstudio-prod.eu-central-1.amazonaws.com": 1,
  "emrappui-prod.eu-north-1.amazonaws.com": 1,
  "emrnotebooks-prod.eu-north-1.amazonaws.com": 1,
  "emrstudio-prod.eu-north-1.amazonaws.com": 1,
  "emrappui-prod.eu-south-1.amazonaws.com": 1,
  "emrnotebooks-prod.eu-south-1.amazonaws.com": 1,
  "emrstudio-prod.eu-south-1.amazonaws.com": 1,
  "emrappui-prod.eu-west-1.amazonaws.com": 1,
  "emrnotebooks-prod.eu-west-1.amazonaws.com": 1,
  "emrstudio-prod.eu-west-1.amazonaws.com": 1,
  "emrappui-prod.eu-west-2.amazonaws.com": 1,
  "emrnotebooks-prod.eu-west-2.amazonaws.com": 1,
  "emrstudio-prod.eu-west-2.amazonaws.com": 1,
  "emrappui-prod.eu-west-3.amazonaws.com": 1,
  "emrnotebooks-prod.eu-west-3.amazonaws.com": 1,
  "emrstudio-prod.eu-west-3.amazonaws.com": 1,
  "emrappui-prod.me-central-1.amazonaws.com": 1,
  "emrnotebooks-prod.me-central-1.amazonaws.com": 1,
  "emrstudio-prod.me-central-1.amazonaws.com": 1,
  "emrappui-prod.me-south-1.amazonaws.com": 1,
  "emrnotebooks-prod.me-south-1.amazonaws.com": 1,
  "emrstudio-prod.me-south-1.amazonaws.com": 1,
  "emrappui-prod.sa-east-1.amazonaws.com": 1,
  "emrnotebooks-prod.sa-east-1.amazonaws.com": 1,
  "emrstudio-prod.sa-east-1.amazonaws.com": 1,
  "emrappui-prod.us-east-1.amazonaws.com": 1,
  "emrnotebooks-prod.us-east-1.amazonaws.com": 1,
  "emrstudio-prod.us-east-1.amazonaws.com": 1,
  "emrappui-prod.us-east-2.amazonaws.com": 1,
  "emrnotebooks-prod.us-east-2.amazonaws.com": 1,
  "emrstudio-prod.us-east-2.amazonaws.com": 1,
  "emrappui-prod.us-gov-east-1.amazonaws.com": 1,
  "emrnotebooks-prod.us-gov-east-1.amazonaws.com": 1,
  "emrstudio-prod.us-gov-east-1.amazonaws.com": 1,
  "emrappui-prod.us-gov-west-1.amazonaws.com": 1,
  "emrnotebooks-prod.us-gov-west-1.amazonaws.com": 1,
  "emrstudio-prod.us-gov-west-1.amazonaws.com": 1,
  "emrappui-prod.us-west-1.amazonaws.com": 1,
  "emrnotebooks-prod.us-west-1.amazonaws.com": 1,
  "emrstudio-prod.us-west-1.amazonaws.com": 1,
  "emrappui-prod.us-west-2.amazonaws.com": 1,
  "emrnotebooks-prod.us-west-2.amazonaws.com": 1,
  "emrstudio-prod.us-west-2.amazonaws.com": 1,
  "cn-north-1.airflow.amazonaws.com.cn": 2,
  "cn-northwest-1.airflow.amazonaws.com.cn": 2,
  "ap-northeast-1.airflow.amazonaws.com": 2,
  "ap-northeast-2.airflow.amazonaws.com": 2,
  "ap-south-1.airflow.amazonaws.com": 2,
  "ap-southeast-1.airflow.amazonaws.com": 2,
  "ap-southeast-2.airflow.amazonaws.com": 2,
  "ca-central-1.airflow.amazonaws.com": 2,
  "eu-central-1.airflow.amazonaws.com": 2,
  "eu-north-1.airflow.amazonaws.com": 2,
  "eu-west-1.airflow.amazonaws.com": 2,
  "eu-west-2.airflow.amazonaws.com": 2,
  "eu-west-3.airflow.amazonaws.com": 2,
  "sa-east-1.airflow.amazonaws.com": 2,
  "us-east-1.airflow.amazonaws.com": 2,
  "us-east-2.airflow.amazonaws.com": 2,
  "us-west-2.airflow.amazonaws.com": 2,
  "s3.dualstack.cn-north-1.amazonaws.com.cn": 1,
  "s3-accesspoint.dualstack.cn-north-1.amazonaws.com.cn": 1,
  "s3-website.dualstack.cn-north-1.amazonaws.com.cn": 1,
  "s3.cn-north-1.amazonaws.com.cn": 1,
  "s3-accesspoint.cn-north-1.amazonaws.com.cn": 1,
  "s3-deprecated.cn-north-1.amazonaws.com.cn": 1,
  "s3-object-lambda.cn-north-1.amazonaws.com.cn": 1,
  "s3-website.cn-north-1.amazonaws.com.cn": 1,
  "s3.dualstack.cn-northwest-1.amazonaws.com.cn": 1,
  "s3-accesspoint.dualstack.cn-northwest-1.amazonaws.com.cn": 1,
  "s3.cn-northwest-1.amazonaws.com.cn": 1,
  "s3-accesspoint.cn-northwest-1.amazonaws.com.cn": 1,
  "s3-object-lambda.cn-northwest-1.amazonaws.com.cn": 1,
  "s3-website.cn-northwest-1.amazonaws.com.cn": 1,
  "s3.dualstack.af-south-1.amazonaws.com": 1,
  "s3-accesspoint.dualstack.af-south-1.amazonaws.com": 1,
  "s3-website.dualstack.af-south-1.amazonaws.com": 1,
  "s3.af-south-1.amazonaws.com": 1,
  "s3-accesspoint.af-south-1.amazonaws.com": 1,
  "s3-object-lambda.af-south-1.amazonaws.com": 1,
  "s3-website.af-south-1.amazonaws.com": 1,
  "s3.dualstack.ap-east-1.amazonaws.com": 1,
  "s3-accesspoint.dualstack.ap-east-1.amazonaws.com": 1,
  "s3.ap-east-1.amazonaws.com": 1,
  "s3-accesspoint.ap-east-1.amazonaws.com": 1,
  "s3-object-lambda.ap-east-1.amazonaws.com": 1,
  "s3-website.ap-east-1.amazonaws.com": 1,
  "s3.dualstack.ap-northeast-1.amazonaws.com": 1,
  "s3-accesspoint.dualstack.ap-northeast-1.amazonaws.com": 1,
  "s3-website.dualstack.ap-northeast-1.amazonaws.com": 1,
  "s3.ap-northeast-1.amazonaws.com": 1,
  "s3-accesspoint.ap-northeast-1.amazonaws.com": 1,
  "s3-object-lambda.ap-northeast-1.amazonaws.com": 1,
  "s3-website.ap-northeast-1.amazonaws.com": 1,
  "s3.dualstack.ap-northeast-2.amazonaws.com": 1,
  "s3-accesspoint.dualstack.ap-northeast-2.amazonaws.com": 1,
  "s3-website.dualstack.ap-northeast-2.amazonaws.com": 1,
  "s3.ap-northeast-2.amazonaws.com": 1,
  "s3-accesspoint.ap-northeast-2.amazonaws.com": 1,
  "s3-object-lambda.ap-northeast-2.amazonaws.com": 1,
  "s3-website.ap-northeast-2.amazonaws.com": 1,
  "s3.dualstack.ap-northeast-3.amazonaws.com": 1,
  "s3-accesspoint.dualstack.ap-northeast-3.amazonaws.com": 1,
  "s3-website.dualstack.ap-northeast-3.amazonaws.com": 1,
  "s3.ap-northeast-3.amazonaws.com": 1,
  "s3-accesspoint.ap-northeast-3.amazonaws.com": 1,
  "s3-object-lambda.ap-northeast-3.amazonaws.com": 1,
  "s3-website.ap-northeast-3.amazonaws.com": 1,
  "s3.dualstack.ap-south-1.amazonaws.com": 1,
  "s3-accesspoint.dualstack.ap-south-1.amazonaws.com": 1,
  "s3-website.dualstack.ap-south-1.amazonaws.com": 1,
  "s3.ap-south-1.amazonaws.com": 1,
  "s3-accesspoint.ap-south-1.amazonaws.com": 1,
  "s3-object-lambda.ap-south-1.amazonaws.com": 1,
  "s3-website.ap-south-1.amazonaws.com": 1,
  "s3.dualstack.ap-south-2.amazonaws.com": 1,
  "s3-accesspoint.dualstack.ap-south-2.amazonaws.com": 1,
  "s3.ap-south-2.amazonaws.com": 1,
  "s3-accesspoint.ap-south-2.amazonaws.com": 1,
  "s3-object-lambda.ap-south-2.amazonaws.com": 1,
  "s3-website.ap-south-2.amazonaws.com": 1,
  "s3.dualstack.ap-southeast-1.amazonaws.com": 1,
  "s3-accesspoint.dualstack.ap-southeast-1.amazonaws.com": 1,
  "s3-website.dualstack.ap-southeast-1.amazonaws.com": 1,
  "s3.ap-southeast-1.amazonaws.com": 1,
  "s3-accesspoint.ap-southeast-1.amazonaws.com": 1,
  "s3-object-lambda.ap-southeast-1.amazonaws.com": 1,
  "s3-website.ap-southeast-1.amazonaws.com": 1,
  "s3.dualstack.ap-southeast-2.amazonaws.com": 1,
  "s3-accesspoint.dualstack.ap-southeast-2.amazonaws.com": 1,
  "s3-website.dualstack.ap-southeast-2.amazonaws.com": 1,
  "s3.ap-southeast-2.amazonaws.com": 1,
  "s3-accesspoint.ap-southeast-2.amazonaws.com": 1,
  "s3-object-lambda.ap-southeast-2.amazonaws.com": 1,
  "s3-website.ap-southeast-2.amazonaws.com": 1,
  "s3.dualstack.ap-southeast-3.amazonaws.com": 1,
  "s3-accesspoint.dualstack.ap-southeast-3.amazonaws.com": 1,
  "s3.ap-southeast-3.amazonaws.com": 1,
  "s3-accesspoint.ap-southeast-3.amazonaws.com": 1,
  "s3-object-lambda.ap-southeast-3.amazonaws.com": 1,
  "s3-website.ap-southeast-3.amazonaws.com": 1,
  "s3.dualstack.ap-southeast-4.amazonaws.com": 1,
  "s3-accesspoint.dualstack.ap-southeast-4.amazonaws.com": 1,
  "s3.ap-southeast-4.amazonaws.com": 1,
  "s3-accesspoint.ap-southeast-4.amazonaws.com": 1,
  "s3-object-lambda.ap-southeast-4.amazonaws.com": 1,
  "s3-website.ap-southeast-4.amazonaws.com": 1,
  "s3.dualstack.ca-central-1.amazonaws.com": 1,
  "s3-accesspoint.dualstack.ca-central-1.amazonaws.com": 1,
  "s3-accesspoint-fips.dualstack.ca-central-1.amazonaws.com": 1,
  "s3-fips.dualstack.ca-central-1.amazonaws.com": 1,
  "s3-website.dualstack.ca-central-1.amazonaws.com": 1,
  "s3.ca-central-1.amazonaws.com": 1,
  "s3-accesspoint.ca-central-1.amazonaws.com": 1,
  "s3-accesspoint-fips.ca-central-1.amazonaws.com": 1,
  "s3-fips.ca-central-1.amazonaws.com": 1,
  "s3-object-lambda.ca-central-1.amazonaws.com": 1,
  "s3-website.ca-central-1.amazonaws.com": 1,
  "s3.dualstack.eu-central-1.amazonaws.com": 1,
  "s3-accesspoint.dualstack.eu-central-1.amazonaws.com": 1,
  "s3-website.dualstack.eu-central-1.amazonaws.com": 1,
  "s3.eu-central-1.amazonaws.com": 1,
  "s3-accesspoint.eu-central-1.amazonaws.com": 1,
  "s3-object-lambda.eu-central-1.amazonaws.com": 1,
  "s3-website.eu-central-1.amazonaws.com": 1,
  "s3.dualstack.eu-central-2.amazonaws.com": 1,
  "s3-accesspoint.dualstack.eu-central-2.amazonaws.com": 1,
  "s3.eu-central-2.amazonaws.com": 1,
  "s3-accesspoint.eu-central-2.amazonaws.com": 1,
  "s3-object-lambda.eu-central-2.amazonaws.com": 1,
  "s3-website.eu-central-2.amazonaws.com": 1,
  "s3.dualstack.eu-north-1.amazonaws.com": 1,
  "s3-accesspoint.dualstack.eu-north-1.amazonaws.com": 1,
  "s3.eu-north-1.amazonaws.com": 1,
  "s3-accesspoint.eu-north-1.amazonaws.com": 1,
  "s3-object-lambda.eu-north-1.amazonaws.com": 1,
  "s3-website.eu-north-1.amazonaws.com": 1,
  "s3.dualstack.eu-south-1.amazonaws.com": 1,
  "s3-accesspoint.dualstack.eu-south-1.amazonaws.com": 1,
  "s3-website.dualstack.eu-south-1.amazonaws.com": 1,
  "s3.eu-south-1.amazonaws.com": 1,
  "s3-accesspoint.eu-south-1.amazonaws.com": 1,
  "s3-object-lambda.eu-south-1.amazonaws.com": 1,
  "s3-website.eu-south-1.amazonaws.com": 1,
  "s3.dualstack.eu-south-2.amazonaws.com": 1,
  "s3-accesspoint.dualstack.eu-south-2.amazonaws.com": 1,
  "s3.eu-south-2.amazonaws.com": 1,
  "s3-accesspoint.eu-south-2.amazonaws.com": 1,
  "s3-object-lambda.eu-south-2.amazonaws.com": 1,
  "s3-website.eu-south-2.amazonaws.com": 1,
  "s3.dualstack.eu-west-1.amazonaws.com": 1,
  "s3-accesspoint.dualstack.eu-west-1.amazonaws.com": 1,
  "s3-website.dualstack.eu-west-1.amazonaws.com": 1,
  "s3.eu-west-1.amazonaws.com": 1,
  "s3-accesspoint.eu-west-1.amazonaws.com": 1,
  "s3-deprecated.eu-west-1.amazonaws.com": 1,
  "s3-object-lambda.eu-west-1.amazonaws.com": 1,
  "s3-website.eu-west-1.amazonaws.com": 1,
  "s3.dualstack.eu-west-2.amazonaws.com": 1,
  "s3-accesspoint.dualstack.eu-west-2.amazonaws.com": 1,
  "s3.eu-west-2.amazonaws.com": 1,
  "s3-accesspoint.eu-west-2.amazonaws.com": 1,
  "s3-object-lambda.eu-west-2.amazonaws.com": 1,
  "s3-website.eu-west-2.amazonaws.com": 1,
  "s3.dualstack.eu-west-3.amazonaws.com": 1,
  "s3-accesspoint.dualstack.eu-west-3.amazonaws.com": 1,
  "s3-website.dualstack.eu-west-3.amazonaws.com": 1,
  "s3.eu-west-3.amazonaws.com": 1,
  "s3-accesspoint.eu-west-3.amazonaws.com": 1,
  "s3-object-lambda.eu-west-3.amazonaws.com": 1,
  "s3-website.eu-west-3.amazonaws.com": 1,
  "s3.dualstack.il-central-1.amazonaws.com": 1,
  "s3-accesspoint.dualstack.il-central-1.amazonaws.com": 1,
  "s3.il-central-1.amazonaws.com": 1,
  "s3-accesspoint.il-central-1.amazonaws.com": 1,
  "s3-object-lambda.il-central-1.amazonaws.com": 1,
  "s3-website.il-central-1.amazonaws.com": 1,
  "s3.dualstack.me-central-1.amazonaws.com": 1,
  "s3-accesspoint.dualstack.me-central-1.amazonaws.com": 1,
  "s3.me-central-1.amazonaws.com": 1,
  "s3-accesspoint.me-central-1.amazonaws.com": 1,
  "s3-object-lambda.me-central-1.amazonaws.com": 1,
  "s3-website.me-central-1.amazonaws.com": 1,
  "s3.dualstack.me-south-1.amazonaws.com": 1,
  "s3-accesspoint.dualstack.me-south-1.amazonaws.com": 1,
  "s3.me-south-1.amazonaws.com": 1,
  "s3-accesspoint.me-south-1.amazonaws.com": 1,
  "s3-object-lambda.me-south-1.amazonaws.com": 1,
  "s3-website.me-south-1.amazonaws.com": 1,
  "s3.amazonaws.com": 1,
  "s3-1.amazonaws.com": 1,
  "s3-ap-east-1.amazonaws.com": 1,
  "s3-ap-northeast-1.amazonaws.com": 1,
  "s3-ap-northeast-2.amazonaws.com": 1,
  "s3-ap-northeast-3.amazonaws.com": 1,
  "s3-ap-south-1.amazonaws.com": 1,
  "s3-ap-southeast-1.amazonaws.com": 1,
  "s3-ap-southeast-2.amazonaws.com": 1,
  "s3-ca-central-1.amazonaws.com": 1,
  "s3-eu-central-1.amazonaws.com": 1,
  "s3-eu-north-1.amazonaws.com": 1,
  "s3-eu-west-1.amazonaws.com": 1,
  "s3-eu-west-2.amazonaws.com": 1,
  "s3-eu-west-3.amazonaws.com": 1,
  "s3-external-1.amazonaws.com": 1,
  "s3-fips-us-gov-east-1.amazonaws.com": 1,
  "s3-fips-us-gov-west-1.amazonaws.com": 1,
  "mrap.accesspoint.s3-global.amazonaws.com": 1,
  "s3-me-south-1.amazonaws.com": 1,
  "s3-sa-east-1.amazonaws.com": 1,
  "s3-us-east-2.amazonaws.com": 1,
  "s3-us-gov-east-1.amazonaws.com": 1,
  "s3-us-gov-west-1.amazonaws.com": 1,
  "s3-us-west-1.amazonaws.com": 1,
  "s3-us-west-2.amazonaws.com": 1,
  "s3-website-ap-northeast-1.amazonaws.com": 1,
  "s3-website-ap-southeast-1.amazonaws.com": 1,
  "s3-website-ap-southeast-2.amazonaws.com": 1,
  "s3-website-eu-west-1.amazonaws.com": 1,
  "s3-website-sa-east-1.amazonaws.com": 1,
  "s3-website-us-east-1.amazonaws.com": 1,
  "s3-website-us-gov-west-1.amazonaws.com": 1,
  "s3-website-us-west-1.amazonaws.com": 1,
  "s3-website-us-west-2.amazonaws.com": 1,
  "s3.dualstack.sa-east-1.amazonaws.com": 1,
  "s3-accesspoint.dualstack.sa-east-1.amazonaws.com": 1,
  "s3-website.dualstack.sa-east-1.amazonaws.com": 1,
  "s3.sa-east-1.amazonaws.com": 1,
  "s3-accesspoint.sa-east-1.amazonaws.com": 1,
  "s3-object-lambda.sa-east-1.amazonaws.com": 1,
  "s3-website.sa-east-1.amazonaws.com": 1,
  "s3.dualstack.us-east-1.amazonaws.com": 1,
  "s3-accesspoint.dualstack.us-east-1.amazonaws.com": 1,
  "s3-accesspoint-fips.dualstack.us-east-1.amazonaws.com": 1,
  "s3-fips.dualstack.us-east-1.amazonaws.com": 1,
  "s3-website.dualstack.us-east-1.amazonaws.com": 1,
  "s3.us-east-1.amazonaws.com": 1,
  "s3-accesspoint.us-east-1.amazonaws.com": 1,
  "s3-accesspoint-fips.us-east-1.amazonaws.com": 1,
  "s3-deprecated.us-east-1.amazonaws.com": 1,
  "s3-fips.us-east-1.amazonaws.com": 1,
  "s3-object-lambda.us-east-1.amazonaws.com": 1,
  "s3-website.us-east-1.amazonaws.com": 1,
  "s3.dualstack.us-east-2.amazonaws.com": 1,
  "s3-accesspoint.dualstack.us-east-2.amazonaws.com": 1,
  "s3-accesspoint-fips.dualstack.us-east-2.amazonaws.com": 1,
  "s3-fips.dualstack.us-east-2.amazonaws.com": 1,
  "s3.us-east-2.amazonaws.com": 1,
  "s3-accesspoint.us-east-2.amazonaws.com": 1,
  "s3-accesspoint-fips.us-east-2.amazonaws.com": 1,
  "s3-deprecated.us-east-2.amazonaws.com": 1,
  "s3-fips.us-east-2.amazonaws.com": 1,
  "s3-object-lambda.us-east-2.amazonaws.com": 1,
  "s3-website.us-east-2.amazonaws.com": 1,
  "s3.dualstack.us-gov-east-1.amazonaws.com": 1,
  "s3-accesspoint.dualstack.us-gov-east-1.amazonaws.com": 1,
  "s3-accesspoint-fips.dualstack.us-gov-east-1.amazonaws.com": 1,
  "s3-fips.dualstack.us-gov-east-1.amazonaws.com": 1,
  "s3.us-gov-east-1.amazonaws.com": 1,
  "s3-accesspoint.us-gov-east-1.amazonaws.com": 1,
  "s3-accesspoint-fips.us-gov-east-1.amazonaws.com": 1,
  "s3-fips.us-gov-east-1.amazonaws.com": 1,
  "s3-object-lambda.us-gov-east-1.amazonaws.com": 1,
  "s3-website.us-gov-east-1.amazonaws.com": 1,
  "s3.dualstack.us-gov-west-1.amazonaws.com": 1,
  "s3-accesspoint.dualstack.us-gov-west-1.amazonaws.com": 1,
  "s3-accesspoint-fips.dualstack.us-gov-west-1.amazonaws.com": 1,
  "s3-fips.dualstack.us-gov-west-1.amazonaws.com": 1,
  "s3.us-gov-west-1.amazonaws.com": 1,
  "s3-accesspoint.us-gov-west-1.amazonaws.com": 1,
  "s3-accesspoint-fips.us-gov-west-1.amazonaws.com": 1,
  "s3-fips.us-gov-west-1.amazonaws.com": 1,
  "s3-object-lambda.us-gov-west-1.amazonaws.com": 1,
  "s3-website.us-gov-west-1.amazonaws.com": 1,
  "s3.dualstack.us-west-1.amazonaws.com": 1,
  "s3-accesspoint.dualstack.us-west-1.amazonaws.com": 1,
  "s3-accesspoint-fips.dualstack.us-west-1.amazonaws.com": 1,
  "s3-fips.dualstack.us-west-1.amazonaws.com": 1,
  "s3-website.dualstack.us-west-1.amazonaws.com": 1,
  "s3.us-west-1.amazonaws.com": 1,
  "s3-accesspoint.us-west-1.amazonaws.com": 1,
  "s3-accesspoint-fips.us-west-1.amazonaws.com": 1,
  "s3-fips.us-west-1.amazonaws.com": 1,
  "s3-object-lambda.us-west-1.amazonaws.com": 1,
  "s3-website.us-west-1.amazonaws.com": 1,
  "s3.dualstack.us-west-2.amazonaws.com": 1,
  "s3-accesspoint.dualstack.us-west-2.amazonaws.com": 1,
  "s3-accesspoint-fips.dualstack.us-west-2.amazonaws.com": 1,
  "s3-fips.dualstack.us-west-2.amazonaws.com": 1,
  "s3-website.dualstack.us-west-2.amazonaws.com": 1,
  "s3.us-west-2.amazonaws.com": 1,
  "s3-accesspoint.us-west-2.amazonaws.com": 1,
  "s3-accesspoint-fips.us-west-2.amazonaws.com": 1,
  "s3-deprecated.us-west-2.amazonaws.com": 1,
  "s3-fips.us-west-2.amazonaws.com": 1,
  "s3-object-lambda.us-west-2.amazonaws.com": 1,
  "s3-website.us-west-2.amazonaws.com": 1,
  "notebook.af-south-1.sagemaker.aws": 1,
  "notebook.ap-east-1.sagemaker.aws": 1,
  "notebook.ap-northeast-1.sagemaker.aws": 1,
  "notebook.ap-northeast-2.sagemaker.aws": 1,
  "notebook.ap-northeast-3.sagemaker.aws": 1,
  "notebook.ap-south-1.sagemaker.aws": 1,
  "notebook.ap-south-2.sagemaker.aws": 1,
  "notebook.ap-southeast-1.sagemaker.aws": 1,
  "notebook.ap-southeast-2.sagemaker.aws": 1,
  "notebook.ap-southeast-3.sagemaker.aws": 1,
  "notebook.ap-southeast-4.sagemaker.aws": 1,
  "notebook.ca-central-1.sagemaker.aws": 1,
  "notebook.eu-central-1.sagemaker.aws": 1,
  "notebook.eu-central-2.sagemaker.aws": 1,
  "notebook.eu-north-1.sagemaker.aws": 1,
  "notebook.eu-south-1.sagemaker.aws": 1,
  "notebook.eu-south-2.sagemaker.aws": 1,
  "notebook.eu-west-1.sagemaker.aws": 1,
  "notebook.eu-west-2.sagemaker.aws": 1,
  "notebook.eu-west-3.sagemaker.aws": 1,
  "notebook.il-central-1.sagemaker.aws": 1,
  "notebook.me-central-1.sagemaker.aws": 1,
  "notebook.me-south-1.sagemaker.aws": 1,
  "notebook.sa-east-1.sagemaker.aws": 1,
  "notebook.us-east-1.sagemaker.aws": 1,
  "notebook-fips.us-east-1.sagemaker.aws": 1,
  "notebook.us-east-2.sagemaker.aws": 1,
  "notebook-fips.us-east-2.sagemaker.aws": 1,
  "notebook.us-gov-east-1.sagemaker.aws": 1,
  "notebook-fips.us-gov-east-1.sagemaker.aws": 1,
  "notebook.us-gov-west-1.sagemaker.aws": 1,
  "notebook-fips.us-gov-west-1.sagemaker.aws": 1,
  "notebook.us-west-1.sagemaker.aws": 1,
  "notebook.us-west-2.sagemaker.aws": 1,
  "notebook-fips.us-west-2.sagemaker.aws": 1,
  "notebook.cn-north-1.sagemaker.com.cn": 1,
  "notebook.cn-northwest-1.sagemaker.com.cn": 1,
  "studio.af-south-1.sagemaker.aws": 1,
  "studio.ap-east-1.sagemaker.aws": 1,
  "studio.ap-northeast-1.sagemaker.aws": 1,
  "studio.ap-northeast-2.sagemaker.aws": 1,
  "studio.ap-northeast-3.sagemaker.aws": 1,
  "studio.ap-south-1.sagemaker.aws": 1,
  "studio.ap-southeast-1.sagemaker.aws": 1,
  "studio.ap-southeast-2.sagemaker.aws": 1,
  "studio.ap-southeast-3.sagemaker.aws": 1,
  "studio.ca-central-1.sagemaker.aws": 1,
  "studio.eu-central-1.sagemaker.aws": 1,
  "studio.eu-north-1.sagemaker.aws": 1,
  "studio.eu-south-1.sagemaker.aws": 1,
  "studio.eu-west-1.sagemaker.aws": 1,
  "studio.eu-west-2.sagemaker.aws": 1,
  "studio.eu-west-3.sagemaker.aws": 1,
  "studio.il-central-1.sagemaker.aws": 1,
  "studio.me-central-1.sagemaker.aws": 1,
  "studio.me-south-1.sagemaker.aws": 1,
  "studio.sa-east-1.sagemaker.aws": 1,
  "studio.us-east-1.sagemaker.aws": 1,
  "studio.us-east-2.sagemaker.aws": 1,
  "studio.us-gov-east-1.sagemaker.aws": 1,
  "studio-fips.us-gov-east-1.sagemaker.aws": 1,
  "studio.us-gov-west-1.sagemaker.aws": 1,
  "studio-fips.us-gov-west-1.sagemaker.aws": 1,
  "studio.us-west-1.sagemaker.aws": 1,
  "studio.us-west-2.sagemaker.aws": 1,
  "studio.cn-north-1.sagemaker.com.cn": 1,
  "studio.cn-northwest-1.sagemaker.com.cn": 1,
  "analytics-gateway.ap-northeast-1.amazonaws.com": 1,
  "analytics-gateway.ap-northeast-2.amazonaws.com": 1,
  "analytics-gateway.ap-south-1.amazonaws.com": 1,
  "analytics-gateway.ap-southeast-1.amazonaws.com": 1,
  "analytics-gateway.ap-southeast-2.amazonaws.com": 1,
  "analytics-gateway.eu-central-1.amazonaws.com": 1,
  "analytics-gateway.eu-west-1.amazonaws.com": 1,
  "analytics-gateway.us-east-1.amazonaws.com": 1,
  "analytics-gateway.us-east-2.amazonaws.com": 1,
  "analytics-gateway.us-west-2.amazonaws.com": 1,
  "amplifyapp.com": 2,
  "awsapprunner.com": 2,
  "webview-assets.aws-cloud9.af-south-1.amazonaws.com": 1,
  "vfs.cloud9.af-south-1.amazonaws.com": 1,
  "webview-assets.cloud9.af-south-1.amazonaws.com": 1,
  "webview-assets.aws-cloud9.ap-east-1.amazonaws.com": 1,
  "vfs.cloud9.ap-east-1.amazonaws.com": 1,
  "webview-assets.cloud9.ap-east-1.amazonaws.com": 1,
  "webview-assets.aws-cloud9.ap-northeast-1.amazonaws.com": 1,
  "vfs.cloud9.ap-northeast-1.amazonaws.com": 1,
  "webview-assets.cloud9.ap-northeast-1.amazonaws.com": 1,
  "webview-assets.aws-cloud9.ap-northeast-2.amazonaws.com": 1,
  "vfs.cloud9.ap-northeast-2.amazonaws.com": 1,
  "webview-assets.cloud9.ap-northeast-2.amazonaws.com": 1,
  "webview-assets.aws-cloud9.ap-northeast-3.amazonaws.com": 1,
  "vfs.cloud9.ap-northeast-3.amazonaws.com": 1,
  "webview-assets.cloud9.ap-northeast-3.amazonaws.com": 1,
  "webview-assets.aws-cloud9.ap-south-1.amazonaws.com": 1,
  "vfs.cloud9.ap-south-1.amazonaws.com": 1,
  "webview-assets.cloud9.ap-south-1.amazonaws.com": 1,
  "webview-assets.aws-cloud9.ap-southeast-1.amazonaws.com": 1,
  "vfs.cloud9.ap-southeast-1.amazonaws.com": 1,
  "webview-assets.cloud9.ap-southeast-1.amazonaws.com": 1,
  "webview-assets.aws-cloud9.ap-southeast-2.amazonaws.com": 1,
  "vfs.cloud9.ap-southeast-2.amazonaws.com": 1,
  "webview-assets.cloud9.ap-southeast-2.amazonaws.com": 1,
  "webview-assets.aws-cloud9.ca-central-1.amazonaws.com": 1,
  "vfs.cloud9.ca-central-1.amazonaws.com": 1,
  "webview-assets.cloud9.ca-central-1.amazonaws.com": 1,
  "webview-assets.aws-cloud9.eu-central-1.amazonaws.com": 1,
  "vfs.cloud9.eu-central-1.amazonaws.com": 1,
  "webview-assets.cloud9.eu-central-1.amazonaws.com": 1,
  "webview-assets.aws-cloud9.eu-north-1.amazonaws.com": 1,
  "vfs.cloud9.eu-north-1.amazonaws.com": 1,
  "webview-assets.cloud9.eu-north-1.amazonaws.com": 1,
  "webview-assets.aws-cloud9.eu-south-1.amazonaws.com": 1,
  "vfs.cloud9.eu-south-1.amazonaws.com": 1,
  "webview-assets.cloud9.eu-south-1.amazonaws.com": 1,
  "webview-assets.aws-cloud9.eu-west-1.amazonaws.com": 1,
  "vfs.cloud9.eu-west-1.amazonaws.com": 1,
  "webview-assets.cloud9.eu-west-1.amazonaws.com": 1,
  "webview-assets.aws-cloud9.eu-west-2.amazonaws.com": 1,
  "vfs.cloud9.eu-west-2.amazonaws.com": 1,
  "webview-assets.cloud9.eu-west-2.amazonaws.com": 1,
  "webview-assets.aws-cloud9.eu-west-3.amazonaws.com": 1,
  "vfs.cloud9.eu-west-3.amazonaws.com": 1,
  "webview-assets.cloud9.eu-west-3.amazonaws.com": 1,
  "webview-assets.aws-cloud9.me-south-1.amazonaws.com": 1,
  "vfs.cloud9.me-south-1.amazonaws.com": 1,
  "webview-assets.cloud9.me-south-1.amazonaws.com": 1,
  "webview-assets.aws-cloud9.sa-east-1.amazonaws.com": 1,
  "vfs.cloud9.sa-east-1.amazonaws.com": 1,
  "webview-assets.cloud9.sa-east-1.amazonaws.com": 1,
  "webview-assets.aws-cloud9.us-east-1.amazonaws.com": 1,
  "vfs.cloud9.us-east-1.amazonaws.com": 1,
  "webview-assets.cloud9.us-east-1.amazonaws.com": 1,
  "webview-assets.aws-cloud9.us-east-2.amazonaws.com": 1,
  "vfs.cloud9.us-east-2.amazonaws.com": 1,
  "webview-assets.cloud9.us-east-2.amazonaws.com": 1,
  "webview-assets.aws-cloud9.us-west-1.amazonaws.com": 1,
  "vfs.cloud9.us-west-1.amazonaws.com": 1,
  "webview-assets.cloud9.us-west-1.amazonaws.com": 1,
  "webview-assets.aws-cloud9.us-west-2.amazonaws.com": 1,
  "vfs.cloud9.us-west-2.amazonaws.com": 1,
  "webview-assets.cloud9.us-west-2.amazonaws.com": 1,
  "cn-north-1.eb.amazonaws.com.cn": 1,
  "cn-northwest-1.eb.amazonaws.com.cn": 1,
  "elasticbeanstalk.com": 1,
  "af-south-1.elasticbeanstalk.com": 1,
  "ap-east-1.elasticbeanstalk.com": 1,
  "ap-northeast-1.elasticbeanstalk.com": 1,
  "ap-northeast-2.elasticbeanstalk.com": 1,
  "ap-northeast-3.elasticbeanstalk.com": 1,
  "ap-south-1.elasticbeanstalk.com": 1,
  "ap-southeast-1.elasticbeanstalk.com": 1,
  "ap-southeast-2.elasticbeanstalk.com": 1,
  "ap-southeast-3.elasticbeanstalk.com": 1,
  "ca-central-1.elasticbeanstalk.com": 1,
  "eu-central-1.elasticbeanstalk.com": 1,
  "eu-north-1.elasticbeanstalk.com": 1,
  "eu-south-1.elasticbeanstalk.com": 1,
  "eu-west-1.elasticbeanstalk.com": 1,
  "eu-west-2.elasticbeanstalk.com": 1,
  "eu-west-3.elasticbeanstalk.com": 1,
  "il-central-1.elasticbeanstalk.com": 1,
  "me-south-1.elasticbeanstalk.com": 1,
  "sa-east-1.elasticbeanstalk.com": 1,
  "us-east-1.elasticbeanstalk.com": 1,
  "us-east-2.elasticbeanstalk.com": 1,
  "us-gov-east-1.elasticbeanstalk.com": 1,
  "us-gov-west-1.elasticbeanstalk.com": 1,
  "us-west-1.elasticbeanstalk.com": 1,
  "us-west-2.elasticbeanstalk.com": 1,
  "elb.amazonaws.com.cn": 2,
  "elb.amazonaws.com": 2,
  "awsglobalaccelerator.com": 1,
  "eero.online": 1,
  "eero-stage.online": 1,
  "t3l3p0rt.net": 1,
  "tele.amune.org": 1,
  "apigee.io": 1,
  "siiites.com": 1,
  "appspacehosted.com": 1,
  "appspaceusercontent.com": 1,
  "appudo.net": 1,
  "on-aptible.com": 1,
  "user.aseinet.ne.jp": 1,
  "gv.vc": 1,
  "d.gv.vc": 1,
  "user.party.eus": 1,
  "pimienta.org": 1,
  "poivron.org": 1,
  "potager.org": 1,
  "sweetpepper.org": 1,
  "myasustor.com": 1,
  "cdn.prod.atlassian-dev.net": 1,
  "translated.page": 1,
  "autocode.dev": 1,
  "myfritz.net": 1,
  "onavstack.net": 1,
  "awdev.ca": 2,
  "advisor.ws": 2,
  "ecommerce-shop.pl": 1,
  "b-data.io": 1,
  "backplaneapp.io": 1,
  "balena-devices.com": 1,
  "rs.ba": 1,
  "banzai.cloud": 2,
  "app.banzaicloud.io": 1,
  "backyards.banzaicloud.io": 2,
  "base.ec": 1,
  "official.ec": 1,
  "buyshop.jp": 1,
  "fashionstore.jp": 1,
  "handcrafted.jp": 1,
  "kawaiishop.jp": 1,
  "supersale.jp": 1,
  "theshop.jp": 1,
  "shopselect.net": 1,
  "base.shop": 1,
  "beagleboard.io": 1,
  "beget.app": 2,
  "betainabox.com": 1,
  "bnr.la": 1,
  "bitbucket.io": 1,
  "blackbaudcdn.net": 1,
  "of.je": 1,
  "bluebite.io": 1,
  "boomla.net": 1,
  "boutir.com": 1,
  "boxfuse.io": 1,
  "square7.ch": 1,
  "bplaced.com": 1,
  "bplaced.de": 1,
  "square7.de": 1,
  "bplaced.net": 1,
  "square7.net": 1,
  "shop.brendly.rs": 1,
  "browsersafetymark.io": 1,
  "uk0.bigv.io": 1,
  "dh.bytemark.co.uk": 1,
  "vm.bytemark.co.uk": 1,
  "cafjs.com": 1,
  "mycd.eu": 1,
  "canva-apps.cn": 1,
  "canva-apps.com": 1,
  "drr.ac": 1,
  "uwu.ai": 1,
  "carrd.co": 1,
  "crd.co": 1,
  "ju.mp": 1,
  "ae.org": 1,
  "br.com": 1,
  "cn.com": 1,
  "com.de": 1,
  "com.se": 1,
  "de.com": 1,
  "eu.com": 1,
  "gb.net": 1,
  "hu.net": 1,
  "jp.net": 1,
  "jpn.com": 1,
  "mex.com": 1,
  "ru.com": 1,
  "sa.com": 1,
  "se.net": 1,
  "uk.com": 1,
  "uk.net": 1,
  "us.com": 1,
  "za.bz": 1,
  "za.com": 1,
  "ar.com": 1,
  "hu.com": 1,
  "kr.com": 1,
  "no.com": 1,
  "qc.com": 1,
  "uy.com": 1,
  "africa.com": 1,
  "gr.com": 1,
  "in.net": 1,
  "web.in": 1,
  "us.org": 1,
  "co.com": 1,
  "aus.basketball": 1,
  "nz.basketball": 1,
  "radio.am": 1,
  "radio.fm": 1,
  "c.la": 1,
  "certmgr.org": 1,
  "cx.ua": 1,
  "discourse.group": 1,
  "discourse.team": 1,
  "cleverapps.io": 1,
  "clerk.app": 1,
  "clerkstage.app": 1,
  "lcl.dev": 2,
  "lclstage.dev": 2,
  "stg.dev": 2,
  "stgstage.dev": 2,
  "clickrising.net": 1,
  "c66.me": 1,
  "cloud66.ws": 1,
  "cloud66.zone": 1,
  "jdevcloud.com": 1,
  "wpdevcloud.com": 1,
  "cloudaccess.host": 1,
  "freesite.host": 1,
  "cloudaccess.net": 1,
  "cloudcontrolled.com": 1,
  "cloudcontrolapp.com": 1,
  "cloudera.site": 2,
  "cf-ipfs.com": 1,
  "cloudflare-ipfs.com": 1,
  "trycloudflare.com": 1,
  "pages.dev": 1,
  "r2.dev": 1,
  "workers.dev": 1,
  "wnext.app": 1,
  "co.ca": 1,
  "otap.co": 2,
  "co.cz": 1,
  "c.cdn77.org": 1,
  "cdn77-ssl.net": 1,
  "r.cdn77.net": 1,
  "rsc.cdn77.org": 1,
  "ssl.origin.cdn77-secure.org": 1,
  "cloudns.asia": 1,
  "cloudns.biz": 1,
  "cloudns.club": 1,
  "cloudns.cc": 1,
  "cloudns.eu": 1,
  "cloudns.in": 1,
  "cloudns.info": 1,
  "cloudns.org": 1,
  "cloudns.pro": 1,
  "cloudns.pw": 1,
  "cloudns.us": 1,
  "cnpy.gdn": 1,
  "codeberg.page": 1,
  "co.nl": 1,
  "co.no": 1,
  "webhosting.be": 1,
  "hosting-cluster.nl": 1,
  "ac.ru": 1,
  "edu.ru": 1,
  "gov.ru": 1,
  "int.ru": 1,
  "mil.ru": 1,
  "test.ru": 1,
  "dyn.cosidns.de": 1,
  "dynamisches-dns.de": 1,
  "dnsupdater.de": 1,
  "internet-dns.de": 1,
  "l-o-g-i-n.de": 1,
  "dynamic-dns.info": 1,
  "feste-ip.net": 1,
  "knx-server.net": 1,
  "static-access.net": 1,
  "realm.cz": 1,
  "cryptonomic.net": 2,
  "cupcake.is": 1,
  "curv.dev": 1,
  "customer-oci.com": 2,
  "oci.customer-oci.com": 2,
  "ocp.customer-oci.com": 2,
  "ocs.customer-oci.com": 2,
  "cyon.link": 1,
  "cyon.site": 1,
  "fnwk.site": 1,
  "folionetwork.site": 1,
  "platform0.app": 1,
  "daplie.me": 1,
  "localhost.daplie.me": 1,
  "dattolocal.com": 1,
  "dattorelay.com": 1,
  "dattoweb.com": 1,
  "mydatto.com": 1,
  "dattolocal.net": 1,
  "mydatto.net": 1,
  "biz.dk": 1,
  "co.dk": 1,
  "firm.dk": 1,
  "reg.dk": 1,
  "store.dk": 1,
  "dyndns.dappnode.io": 1,
  "dapps.earth": 2,
  "bzz.dapps.earth": 2,
  "builtwithdark.com": 1,
  "demo.datadetect.com": 1,
  "instance.datadetect.com": 1,
  "edgestack.me": 1,
  "ddns5.com": 1,
  "debian.net": 1,
  "deno.dev": 1,
  "deno-staging.dev": 1,
  "dedyn.io": 1,
  "deta.app": 1,
  "deta.dev": 1,
  "rss.my.id": 2,
  "diher.solutions": 2,
  "discordsays.com": 1,
  "discordsez.com": 1,
  "jozi.biz": 1,
  "dnshome.de": 1,
  "online.th": 1,
  "shop.th": 1,
  "drayddns.com": 1,
  "shoparena.pl": 1,
  "dreamhosters.com": 1,
  "mydrobo.com": 1,
  "drud.io": 1,
  "drud.us": 1,
  "duckdns.org": 1,
  "bip.sh": 1,
  "bitbridge.net": 1,
  "dy.fi": 1,
  "tunk.org": 1,
  "dyndns-at-home.com": 1,
  "dyndns-at-work.com": 1,
  "dyndns-blog.com": 1,
  "dyndns-free.com": 1,
  "dyndns-home.com": 1,
  "dyndns-ip.com": 1,
  "dyndns-mail.com": 1,
  "dyndns-office.com": 1,
  "dyndns-pics.com": 1,
  "dyndns-remote.com": 1,
  "dyndns-server.com": 1,
  "dyndns-web.com": 1,
  "dyndns-wiki.com": 1,
  "dyndns-work.com": 1,
  "dyndns.biz": 1,
  "dyndns.info": 1,
  "dyndns.org": 1,
  "dyndns.tv": 1,
  "at-band-camp.net": 1,
  "ath.cx": 1,
  "barrel-of-knowledge.info": 1,
  "barrell-of-knowledge.info": 1,
  "better-than.tv": 1,
  "blogdns.com": 1,
  "blogdns.net": 1,
  "blogdns.org": 1,
  "blogsite.org": 1,
  "boldlygoingnowhere.org": 1,
  "broke-it.net": 1,
  "buyshouses.net": 1,
  "cechire.com": 1,
  "dnsalias.com": 1,
  "dnsalias.net": 1,
  "dnsalias.org": 1,
  "dnsdojo.com": 1,
  "dnsdojo.net": 1,
  "dnsdojo.org": 1,
  "does-it.net": 1,
  "doesntexist.com": 1,
  "doesntexist.org": 1,
  "dontexist.com": 1,
  "dontexist.net": 1,
  "dontexist.org": 1,
  "doomdns.com": 1,
  "doomdns.org": 1,
  "dvrdns.org": 1,
  "dyn-o-saur.com": 1,
  "dynalias.com": 1,
  "dynalias.net": 1,
  "dynalias.org": 1,
  "dynathome.net": 1,
  "dyndns.ws": 1,
  "endofinternet.net": 1,
  "endofinternet.org": 1,
  "endoftheinternet.org": 1,
  "est-a-la-maison.com": 1,
  "est-a-la-masion.com": 1,
  "est-le-patron.com": 1,
  "est-mon-blogueur.com": 1,
  "for-better.biz": 1,
  "for-more.biz": 1,
  "for-our.info": 1,
  "for-some.biz": 1,
  "for-the.biz": 1,
  "forgot.her.name": 1,
  "forgot.his.name": 1,
  "from-ak.com": 1,
  "from-al.com": 1,
  "from-ar.com": 1,
  "from-az.net": 1,
  "from-ca.com": 1,
  "from-co.net": 1,
  "from-ct.com": 1,
  "from-dc.com": 1,
  "from-de.com": 1,
  "from-fl.com": 1,
  "from-ga.com": 1,
  "from-hi.com": 1,
  "from-ia.com": 1,
  "from-id.com": 1,
  "from-il.com": 1,
  "from-in.com": 1,
  "from-ks.com": 1,
  "from-ky.com": 1,
  "from-la.net": 1,
  "from-ma.com": 1,
  "from-md.com": 1,
  "from-me.org": 1,
  "from-mi.com": 1,
  "from-mn.com": 1,
  "from-mo.com": 1,
  "from-ms.com": 1,
  "from-mt.com": 1,
  "from-nc.com": 1,
  "from-nd.com": 1,
  "from-ne.com": 1,
  "from-nh.com": 1,
  "from-nj.com": 1,
  "from-nm.com": 1,
  "from-nv.com": 1,
  "from-ny.net": 1,
  "from-oh.com": 1,
  "from-ok.com": 1,
  "from-or.com": 1,
  "from-pa.com": 1,
  "from-pr.com": 1,
  "from-ri.com": 1,
  "from-sc.com": 1,
  "from-sd.com": 1,
  "from-tn.com": 1,
  "from-tx.com": 1,
  "from-ut.com": 1,
  "from-va.com": 1,
  "from-vt.com": 1,
  "from-wa.com": 1,
  "from-wi.com": 1,
  "from-wv.com": 1,
  "from-wy.com": 1,
  "ftpaccess.cc": 1,
  "fuettertdasnetz.de": 1,
  "game-host.org": 1,
  "game-server.cc": 1,
  "getmyip.com": 1,
  "gets-it.net": 1,
  "go.dyndns.org": 1,
  "gotdns.com": 1,
  "gotdns.org": 1,
  "groks-the.info": 1,
  "groks-this.info": 1,
  "ham-radio-op.net": 1,
  "here-for-more.info": 1,
  "hobby-site.com": 1,
  "hobby-site.org": 1,
  "home.dyndns.org": 1,
  "homedns.org": 1,
  "homeftp.net": 1,
  "homeftp.org": 1,
  "homeip.net": 1,
  "homelinux.com": 1,
  "homelinux.net": 1,
  "homelinux.org": 1,
  "homeunix.com": 1,
  "homeunix.net": 1,
  "homeunix.org": 1,
  "iamallama.com": 1,
  "in-the-band.net": 1,
  "is-a-anarchist.com": 1,
  "is-a-blogger.com": 1,
  "is-a-bookkeeper.com": 1,
  "is-a-bruinsfan.org": 1,
  "is-a-bulls-fan.com": 1,
  "is-a-candidate.org": 1,
  "is-a-caterer.com": 1,
  "is-a-celticsfan.org": 1,
  "is-a-chef.com": 1,
  "is-a-chef.net": 1,
  "is-a-chef.org": 1,
  "is-a-conservative.com": 1,
  "is-a-cpa.com": 1,
  "is-a-cubicle-slave.com": 1,
  "is-a-democrat.com": 1,
  "is-a-designer.com": 1,
  "is-a-doctor.com": 1,
  "is-a-financialadvisor.com": 1,
  "is-a-geek.com": 1,
  "is-a-geek.net": 1,
  "is-a-geek.org": 1,
  "is-a-green.com": 1,
  "is-a-guru.com": 1,
  "is-a-hard-worker.com": 1,
  "is-a-hunter.com": 1,
  "is-a-knight.org": 1,
  "is-a-landscaper.com": 1,
  "is-a-lawyer.com": 1,
  "is-a-liberal.com": 1,
  "is-a-libertarian.com": 1,
  "is-a-linux-user.org": 1,
  "is-a-llama.com": 1,
  "is-a-musician.com": 1,
  "is-a-nascarfan.com": 1,
  "is-a-nurse.com": 1,
  "is-a-painter.com": 1,
  "is-a-patsfan.org": 1,
  "is-a-personaltrainer.com": 1,
  "is-a-photographer.com": 1,
  "is-a-player.com": 1,
  "is-a-republican.com": 1,
  "is-a-rockstar.com": 1,
  "is-a-socialist.com": 1,
  "is-a-soxfan.org": 1,
  "is-a-student.com": 1,
  "is-a-teacher.com": 1,
  "is-a-techie.com": 1,
  "is-a-therapist.com": 1,
  "is-an-accountant.com": 1,
  "is-an-actor.com": 1,
  "is-an-actress.com": 1,
  "is-an-anarchist.com": 1,
  "is-an-artist.com": 1,
  "is-an-engineer.com": 1,
  "is-an-entertainer.com": 1,
  "is-by.us": 1,
  "is-certified.com": 1,
  "is-found.org": 1,
  "is-gone.com": 1,
  "is-into-anime.com": 1,
  "is-into-cars.com": 1,
  "is-into-cartoons.com": 1,
  "is-into-games.com": 1,
  "is-leet.com": 1,
  "is-lost.org": 1,
  "is-not-certified.com": 1,
  "is-saved.org": 1,
  "is-slick.com": 1,
  "is-uberleet.com": 1,
  "is-very-bad.org": 1,
  "is-very-evil.org": 1,
  "is-very-good.org": 1,
  "is-very-nice.org": 1,
  "is-very-sweet.org": 1,
  "is-with-theband.com": 1,
  "isa-geek.com": 1,
  "isa-geek.net": 1,
  "isa-geek.org": 1,
  "isa-hockeynut.com": 1,
  "issmarterthanyou.com": 1,
  "isteingeek.de": 1,
  "istmein.de": 1,
  "kicks-ass.net": 1,
  "kicks-ass.org": 1,
  "knowsitall.info": 1,
  "land-4-sale.us": 1,
  "lebtimnetz.de": 1,
  "leitungsen.de": 1,
  "likes-pie.com": 1,
  "likescandy.com": 1,
  "merseine.nu": 1,
  "mine.nu": 1,
  "misconfused.org": 1,
  "mypets.ws": 1,
  "myphotos.cc": 1,
  "neat-url.com": 1,
  "office-on-the.net": 1,
  "on-the-web.tv": 1,
  "podzone.net": 1,
  "podzone.org": 1,
  "readmyblog.org": 1,
  "saves-the-whales.com": 1,
  "scrapper-site.net": 1,
  "scrapping.cc": 1,
  "selfip.biz": 1,
  "selfip.com": 1,
  "selfip.info": 1,
  "selfip.net": 1,
  "selfip.org": 1,
  "sells-for-less.com": 1,
  "sells-for-u.com": 1,
  "sells-it.net": 1,
  "sellsyourhome.org": 1,
  "servebbs.com": 1,
  "servebbs.net": 1,
  "servebbs.org": 1,
  "serveftp.net": 1,
  "serveftp.org": 1,
  "servegame.org": 1,
  "shacknet.nu": 1,
  "simple-url.com": 1,
  "space-to-rent.com": 1,
  "stuff-4-sale.org": 1,
  "stuff-4-sale.us": 1,
  "teaches-yoga.com": 1,
  "thruhere.net": 1,
  "traeumtgerade.de": 1,
  "webhop.biz": 1,
  "webhop.info": 1,
  "webhop.net": 1,
  "webhop.org": 1,
  "worse-than.tv": 1,
  "writesthisblog.com": 1,
  "ddnss.de": 1,
  "dyn.ddnss.de": 1,
  "dyndns.ddnss.de": 1,
  "dyndns1.de": 1,
  "dyn-ip24.de": 1,
  "home-webserver.de": 1,
  "dyn.home-webserver.de": 1,
  "myhome-server.de": 1,
  "ddnss.org": 1,
  "definima.net": 1,
  "definima.io": 1,
  "ondigitalocean.app": 1,
  "digitaloceanspaces.com": 2,
  "bci.dnstrace.pro": 1,
  "ddnsfree.com": 1,
  "ddnsgeek.com": 1,
  "giize.com": 1,
  "gleeze.com": 1,
  "kozow.com": 1,
  "loseyourip.com": 1,
  "ooguy.com": 1,
  "theworkpc.com": 1,
  "casacam.net": 1,
  "dynu.net": 1,
  "accesscam.org": 1,
  "camdvr.org": 1,
  "freeddns.org": 1,
  "mywire.org": 1,
  "webredirect.org": 1,
  "myddns.rocks": 1,
  "blogsite.xyz": 1,
  "dynv6.net": 1,
  "e4.cz": 1,
  "easypanel.app": 1,
  "easypanel.host": 1,
  "elementor.cloud": 1,
  "elementor.cool": 1,
  "en-root.fr": 1,
  "mytuleap.com": 1,
  "tuleap-partners.com": 1,
  "encr.app": 1,
  "encoreapi.com": 1,
  "onred.one": 1,
  "staging.onred.one": 1,
  "eu.encoway.cloud": 1,
  "eu.org": 1,
  "al.eu.org": 1,
  "asso.eu.org": 1,
  "at.eu.org": 1,
  "au.eu.org": 1,
  "be.eu.org": 1,
  "bg.eu.org": 1,
  "ca.eu.org": 1,
  "cd.eu.org": 1,
  "ch.eu.org": 1,
  "cn.eu.org": 1,
  "cy.eu.org": 1,
  "cz.eu.org": 1,
  "de.eu.org": 1,
  "dk.eu.org": 1,
  "edu.eu.org": 1,
  "ee.eu.org": 1,
  "es.eu.org": 1,
  "fi.eu.org": 1,
  "fr.eu.org": 1,
  "gr.eu.org": 1,
  "hr.eu.org": 1,
  "hu.eu.org": 1,
  "ie.eu.org": 1,
  "il.eu.org": 1,
  "in.eu.org": 1,
  "int.eu.org": 1,
  "is.eu.org": 1,
  "it.eu.org": 1,
  "jp.eu.org": 1,
  "kr.eu.org": 1,
  "lt.eu.org": 1,
  "lu.eu.org": 1,
  "lv.eu.org": 1,
  "mc.eu.org": 1,
  "me.eu.org": 1,
  "mk.eu.org": 1,
  "mt.eu.org": 1,
  "my.eu.org": 1,
  "net.eu.org": 1,
  "ng.eu.org": 1,
  "nl.eu.org": 1,
  "no.eu.org": 1,
  "nz.eu.org": 1,
  "paris.eu.org": 1,
  "pl.eu.org": 1,
  "pt.eu.org": 1,
  "q-a.eu.org": 1,
  "ro.eu.org": 1,
  "ru.eu.org": 1,
  "se.eu.org": 1,
  "si.eu.org": 1,
  "sk.eu.org": 1,
  "tr.eu.org": 1,
  "uk.eu.org": 1,
  "us.eu.org": 1,
  "eurodir.ru": 1,
  "eu-1.evennode.com": 1,
  "eu-2.evennode.com": 1,
  "eu-3.evennode.com": 1,
  "eu-4.evennode.com": 1,
  "us-1.evennode.com": 1,
  "us-2.evennode.com": 1,
  "us-3.evennode.com": 1,
  "us-4.evennode.com": 1,
  "twmail.cc": 1,
  "twmail.net": 1,
  "twmail.org": 1,
  "mymailer.com.tw": 1,
  "url.tw": 1,
  "onfabrica.com": 1,
  "apps.fbsbx.com": 1,
  "ru.net": 1,
  "adygeya.ru": 1,
  "bashkiria.ru": 1,
  "bir.ru": 1,
  "cbg.ru": 1,
  "com.ru": 1,
  "dagestan.ru": 1,
  "grozny.ru": 1,
  "kalmykia.ru": 1,
  "kustanai.ru": 1,
  "marine.ru": 1,
  "mordovia.ru": 1,
  "msk.ru": 1,
  "mytis.ru": 1,
  "nalchik.ru": 1,
  "nov.ru": 1,
  "pyatigorsk.ru": 1,
  "spb.ru": 1,
  "vladikavkaz.ru": 1,
  "vladimir.ru": 1,
  "abkhazia.su": 1,
  "adygeya.su": 1,
  "aktyubinsk.su": 1,
  "arkhangelsk.su": 1,
  "armenia.su": 1,
  "ashgabad.su": 1,
  "azerbaijan.su": 1,
  "balashov.su": 1,
  "bashkiria.su": 1,
  "bryansk.su": 1,
  "bukhara.su": 1,
  "chimkent.su": 1,
  "dagestan.su": 1,
  "east-kazakhstan.su": 1,
  "exnet.su": 1,
  "georgia.su": 1,
  "grozny.su": 1,
  "ivanovo.su": 1,
  "jambyl.su": 1,
  "kalmykia.su": 1,
  "kaluga.su": 1,
  "karacol.su": 1,
  "karaganda.su": 1,
  "karelia.su": 1,
  "khakassia.su": 1,
  "krasnodar.su": 1,
  "kurgan.su": 1,
  "kustanai.su": 1,
  "lenug.su": 1,
  "mangyshlak.su": 1,
  "mordovia.su": 1,
  "msk.su": 1,
  "murmansk.su": 1,
  "nalchik.su": 1,
  "navoi.su": 1,
  "north-kazakhstan.su": 1,
  "nov.su": 1,
  "obninsk.su": 1,
  "penza.su": 1,
  "pokrovsk.su": 1,
  "sochi.su": 1,
  "spb.su": 1,
  "tashkent.su": 1,
  "termez.su": 1,
  "togliatti.su": 1,
  "troitsk.su": 1,
  "tselinograd.su": 1,
  "tula.su": 1,
  "tuva.su": 1,
  "vladikavkaz.su": 1,
  "vladimir.su": 1,
  "vologda.su": 1,
  "channelsdvr.net": 1,
  "u.channelsdvr.net": 1,
  "edgecompute.app": 1,
  "fastly-edge.com": 1,
  "fastly-terrarium.com": 1,
  "fastlylb.net": 1,
  "map.fastlylb.net": 1,
  "freetls.fastly.net": 1,
  "map.fastly.net": 1,
  "a.prod.fastly.net": 1,
  "global.prod.fastly.net": 1,
  "a.ssl.fastly.net": 1,
  "b.ssl.fastly.net": 1,
  "global.ssl.fastly.net": 1,
  "user.fm": 2,
  "fastvps-server.com": 1,
  "fastvps.host": 1,
  "myfast.host": 1,
  "fastvps.site": 1,
  "myfast.space": 1,
  "fedorainfracloud.org": 1,
  "fedorapeople.org": 1,
  "cloud.fedoraproject.org": 1,
  "app.os.fedoraproject.org": 1,
  "app.os.stg.fedoraproject.org": 1,
  "conn.uk": 1,
  "copro.uk": 1,
  "hosp.uk": 1,
  "mydobiss.com": 1,
  "fh-muenster.io": 1,
  "filegear.me": 1,
  "filegear-au.me": 1,
  "filegear-de.me": 1,
  "filegear-gb.me": 1,
  "filegear-ie.me": 1,
  "filegear-jp.me": 1,
  "filegear-sg.me": 1,
  "firebaseapp.com": 1,
  "fireweb.app": 1,
  "flap.id": 1,
  "onflashdrive.app": 1,
  "fldrv.com": 1,
  "fly.dev": 1,
  "edgeapp.net": 1,
  "shw.io": 1,
  "flynnhosting.net": 1,
  "forgeblocks.com": 1,
  "id.forgerock.io": 1,
  "framer.app": 1,
  "framercanvas.com": 1,
  "framer.media": 1,
  "framer.photos": 1,
  "framer.website": 1,
  "framer.wiki": 1,
  "frusky.de": 2,
  "ravpage.co.il": 1,
  "0e.vc": 1,
  "freebox-os.com": 1,
  "freeboxos.com": 1,
  "fbx-os.fr": 1,
  "fbxos.fr": 1,
  "freebox-os.fr": 1,
  "freeboxos.fr": 1,
  "freedesktop.org": 1,
  "freemyip.com": 1,
  "wien.funkfeuer.at": 1,
  "futurecms.at": 2,
  "ex.futurecms.at": 2,
  "in.futurecms.at": 2,
  "futurehosting.at": 1,
  "futuremailing.at": 1,
  "ex.ortsinfo.at": 2,
  "kunden.ortsinfo.at": 2,
  "statics.cloud": 2,
  "independent-commission.uk": 1,
  "independent-inquest.uk": 1,
  "independent-inquiry.uk": 1,
  "independent-panel.uk": 1,
  "independent-review.uk": 1,
  "public-inquiry.uk": 1,
  "royal-commission.uk": 1,
  "campaign.gov.uk": 1,
  "service.gov.uk": 1,
  "api.gov.uk": 1,
  "gehirn.ne.jp": 1,
  "usercontent.jp": 1,
  "gentapps.com": 1,
  "gentlentapis.com": 1,
  "lab.ms": 1,
  "cdn-edges.net": 1,
  "ghost.io": 1,
  "gsj.bz": 1,
  "githubusercontent.com": 1,
  "githubpreview.dev": 1,
  "github.io": 1,
  "gitlab.io": 1,
  "gitapp.si": 1,
  "gitpage.si": 1,
  "glitch.me": 1,
  "nog.community": 1,
  "co.ro": 1,
  "shop.ro": 1,
  "lolipop.io": 1,
  "angry.jp": 1,
  "babyblue.jp": 1,
  "babymilk.jp": 1,
  "backdrop.jp": 1,
  "bambina.jp": 1,
  "bitter.jp": 1,
  "blush.jp": 1,
  "boo.jp": 1,
  "boy.jp": 1,
  "boyfriend.jp": 1,
  "but.jp": 1,
  "candypop.jp": 1,
  "capoo.jp": 1,
  "catfood.jp": 1,
  "cheap.jp": 1,
  "chicappa.jp": 1,
  "chillout.jp": 1,
  "chips.jp": 1,
  "chowder.jp": 1,
  "chu.jp": 1,
  "ciao.jp": 1,
  "cocotte.jp": 1,
  "coolblog.jp": 1,
  "cranky.jp": 1,
  "cutegirl.jp": 1,
  "daa.jp": 1,
  "deca.jp": 1,
  "deci.jp": 1,
  "digick.jp": 1,
  "egoism.jp": 1,
  "fakefur.jp": 1,
  "fem.jp": 1,
  "flier.jp": 1,
  "floppy.jp": 1,
  "fool.jp": 1,
  "frenchkiss.jp": 1,
  "girlfriend.jp": 1,
  "girly.jp": 1,
  "gloomy.jp": 1,
  "gonna.jp": 1,
  "greater.jp": 1,
  "hacca.jp": 1,
  "heavy.jp": 1,
  "her.jp": 1,
  "hiho.jp": 1,
  "hippy.jp": 1,
  "holy.jp": 1,
  "hungry.jp": 1,
  "icurus.jp": 1,
  "itigo.jp": 1,
  "jellybean.jp": 1,
  "kikirara.jp": 1,
  "kill.jp": 1,
  "kilo.jp": 1,
  "kuron.jp": 1,
  "littlestar.jp": 1,
  "lolipopmc.jp": 1,
  "lolitapunk.jp": 1,
  "lomo.jp": 1,
  "lovepop.jp": 1,
  "lovesick.jp": 1,
  "main.jp": 1,
  "mods.jp": 1,
  "mond.jp": 1,
  "mongolian.jp": 1,
  "moo.jp": 1,
  "namaste.jp": 1,
  "nikita.jp": 1,
  "nobushi.jp": 1,
  "noor.jp": 1,
  "oops.jp": 1,
  "parallel.jp": 1,
  "parasite.jp": 1,
  "pecori.jp": 1,
  "peewee.jp": 1,
  "penne.jp": 1,
  "pepper.jp": 1,
  "perma.jp": 1,
  "pigboat.jp": 1,
  "pinoko.jp": 1,
  "punyu.jp": 1,
  "pupu.jp": 1,
  "pussycat.jp": 1,
  "pya.jp": 1,
  "raindrop.jp": 1,
  "readymade.jp": 1,
  "sadist.jp": 1,
  "schoolbus.jp": 1,
  "secret.jp": 1,
  "staba.jp": 1,
  "stripper.jp": 1,
  "sub.jp": 1,
  "sunnyday.jp": 1,
  "thick.jp": 1,
  "tonkotsu.jp": 1,
  "under.jp": 1,
  "upper.jp": 1,
  "velvet.jp": 1,
  "verse.jp": 1,
  "versus.jp": 1,
  "vivian.jp": 1,
  "watson.jp": 1,
  "weblike.jp": 1,
  "whitesnow.jp": 1,
  "zombie.jp": 1,
  "heteml.net": 1,
  "cloudapps.digital": 1,
  "london.cloudapps.digital": 1,
  "pymnt.uk": 1,
  "homeoffice.gov.uk": 1,
  "ro.im": 1,
  "goip.de": 1,
  "run.app": 1,
  "a.run.app": 1,
  "web.app": 1,
  "0emm.com": 2,
  "appspot.com": 1,
  "r.appspot.com": 2,
  "codespot.com": 1,
  "googleapis.com": 1,
  "googlecode.com": 1,
  "pagespeedmobilizer.com": 1,
  "publishproxy.com": 1,
  "withgoogle.com": 1,
  "withyoutube.com": 1,
  "gateway.dev": 2,
  "cloud.goog": 1,
  "translate.goog": 1,
  "usercontent.goog": 2,
  "cloudfunctions.net": 1,
  "blogspot.ae": 1,
  "blogspot.al": 1,
  "blogspot.am": 1,
  "blogspot.ba": 1,
  "blogspot.be": 1,
  "blogspot.bg": 1,
  "blogspot.bj": 1,
  "blogspot.ca": 1,
  "blogspot.cf": 1,
  "blogspot.ch": 1,
  "blogspot.cl": 1,
  "blogspot.co.at": 1,
  "blogspot.co.id": 1,
  "blogspot.co.il": 1,
  "blogspot.co.ke": 1,
  "blogspot.co.nz": 1,
  "blogspot.co.uk": 1,
  "blogspot.co.za": 1,
  "blogspot.com": 1,
  "blogspot.com.ar": 1,
  "blogspot.com.au": 1,
  "blogspot.com.br": 1,
  "blogspot.com.by": 1,
  "blogspot.com.co": 1,
  "blogspot.com.cy": 1,
  "blogspot.com.ee": 1,
  "blogspot.com.eg": 1,
  "blogspot.com.es": 1,
  "blogspot.com.mt": 1,
  "blogspot.com.ng": 1,
  "blogspot.com.tr": 1,
  "blogspot.com.uy": 1,
  "blogspot.cv": 1,
  "blogspot.cz": 1,
  "blogspot.de": 1,
  "blogspot.dk": 1,
  "blogspot.fi": 1,
  "blogspot.fr": 1,
  "blogspot.gr": 1,
  "blogspot.hk": 1,
  "blogspot.hr": 1,
  "blogspot.hu": 1,
  "blogspot.ie": 1,
  "blogspot.in": 1,
  "blogspot.is": 1,
  "blogspot.it": 1,
  "blogspot.jp": 1,
  "blogspot.kr": 1,
  "blogspot.li": 1,
  "blogspot.lt": 1,
  "blogspot.lu": 1,
  "blogspot.md": 1,
  "blogspot.mk": 1,
  "blogspot.mr": 1,
  "blogspot.mx": 1,
  "blogspot.my": 1,
  "blogspot.nl": 1,
  "blogspot.no": 1,
  "blogspot.pe": 1,
  "blogspot.pt": 1,
  "blogspot.qa": 1,
  "blogspot.re": 1,
  "blogspot.ro": 1,
  "blogspot.rs": 1,
  "blogspot.ru": 1,
  "blogspot.se": 1,
  "blogspot.sg": 1,
  "blogspot.si": 1,
  "blogspot.sk": 1,
  "blogspot.sn": 1,
  "blogspot.td": 1,
  "blogspot.tw": 1,
  "blogspot.ug": 1,
  "blogspot.vn": 1,
  "goupile.fr": 1,
  "gov.nl": 1,
  "awsmppl.com": 1,
  "xn--gnstigbestellen-zvb.de": 1,
  "xn--gnstigliefern-wob.de": 1,
  "fin.ci": 1,
  "free.hr": 1,
  "caa.li": 1,
  "ua.rs": 1,
  "conf.se": 1,
  "hs.zone": 1,
  "hs.run": 1,
  "hashbang.sh": 1,
  "hasura.app": 1,
  "hasura-app.io": 1,
  "pages.it.hs-heilbronn.de": 1,
  "hepforge.org": 1,
  "herokuapp.com": 1,
  "herokussl.com": 1,
  "ravendb.cloud": 1,
  "ravendb.community": 1,
  "ravendb.me": 1,
  "development.run": 1,
  "ravendb.run": 1,
  "homesklep.pl": 1,
  "secaas.hk": 1,
  "hoplix.shop": 1,
  "orx.biz": 1,
  "biz.gl": 1,
  "col.ng": 1,
  "firm.ng": 1,
  "gen.ng": 1,
  "ltd.ng": 1,
  "ngo.ng": 1,
  "edu.scot": 1,
  "sch.so": 1,
  "ie.ua": 1,
  "hostyhosting.io": 1,
  "xn--hkkinen-5wa.fi": 1,
  "moonscale.io": 2,
  "moonscale.net": 1,
  "iki.fi": 1,
  "ibxos.it": 1,
  "iliadboxos.it": 1,
  "impertrixcdn.com": 1,
  "impertrix.com": 1,
  "smushcdn.com": 1,
  "wphostedmail.com": 1,
  "wpmucdn.com": 1,
  "tempurl.host": 1,
  "wpmudev.host": 1,
  "dyn-berlin.de": 1,
  "in-berlin.de": 1,
  "in-brb.de": 1,
  "in-butter.de": 1,
  "in-dsl.de": 1,
  "in-dsl.net": 1,
  "in-dsl.org": 1,
  "in-vpn.de": 1,
  "in-vpn.net": 1,
  "in-vpn.org": 1,
  "biz.at": 1,
  "info.at": 1,
  "info.cx": 1,
  "ac.leg.br": 1,
  "al.leg.br": 1,
  "am.leg.br": 1,
  "ap.leg.br": 1,
  "ba.leg.br": 1,
  "ce.leg.br": 1,
  "df.leg.br": 1,
  "es.leg.br": 1,
  "go.leg.br": 1,
  "ma.leg.br": 1,
  "mg.leg.br": 1,
  "ms.leg.br": 1,
  "mt.leg.br": 1,
  "pa.leg.br": 1,
  "pb.leg.br": 1,
  "pe.leg.br": 1,
  "pi.leg.br": 1,
  "pr.leg.br": 1,
  "rj.leg.br": 1,
  "rn.leg.br": 1,
  "ro.leg.br": 1,
  "rr.leg.br": 1,
  "rs.leg.br": 1,
  "sc.leg.br": 1,
  "se.leg.br": 1,
  "sp.leg.br": 1,
  "to.leg.br": 1,
  "pixolino.com": 1,
  "na4u.ru": 1,
  "iopsys.se": 1,
  "ipifony.net": 1,
  "iservschule.de": 1,
  "mein-iserv.de": 1,
  "schulplattform.de": 1,
  "schulserver.de": 1,
  "test-iserv.de": 1,
  "iserv.dev": 1,
  "iobb.net": 1,
  "mel.cloudlets.com.au": 1,
  "cloud.interhostsolutions.be": 1,
  "mycloud.by": 1,
  "alp1.ae.flow.ch": 1,
  "appengine.flow.ch": 1,
  "es-1.axarnet.cloud": 1,
  "diadem.cloud": 1,
  "vip.jelastic.cloud": 1,
  "jele.cloud": 1,
  "it1.eur.aruba.jenv-aruba.cloud": 1,
  "it1.jenv-aruba.cloud": 1,
  "keliweb.cloud": 1,
  "cs.keliweb.cloud": 1,
  "oxa.cloud": 1,
  "tn.oxa.cloud": 1,
  "uk.oxa.cloud": 1,
  "primetel.cloud": 1,
  "uk.primetel.cloud": 1,
  "ca.reclaim.cloud": 1,
  "uk.reclaim.cloud": 1,
  "us.reclaim.cloud": 1,
  "ch.trendhosting.cloud": 1,
  "de.trendhosting.cloud": 1,
  "jele.club": 1,
  "amscompute.com": 1,
  "dopaas.com": 1,
  "paas.hosted-by-previder.com": 1,
  "rag-cloud.hosteur.com": 1,
  "rag-cloud-ch.hosteur.com": 1,
  "jcloud.ik-server.com": 1,
  "jcloud-ver-jpc.ik-server.com": 1,
  "demo.jelastic.com": 1,
  "kilatiron.com": 1,
  "paas.massivegrid.com": 1,
  "jed.wafaicloud.com": 1,
  "lon.wafaicloud.com": 1,
  "ryd.wafaicloud.com": 1,
  "j.scaleforce.com.cy": 1,
  "jelastic.dogado.eu": 1,
  "fi.cloudplatform.fi": 1,
  "demo.datacenter.fi": 1,
  "paas.datacenter.fi": 1,
  "jele.host": 1,
  "mircloud.host": 1,
  "paas.beebyte.io": 1,
  "sekd1.beebyteapp.io": 1,
  "jele.io": 1,
  "cloud-fr1.unispace.io": 1,
  "jc.neen.it": 1,
  "cloud.jelastic.open.tim.it": 1,
  "jcloud.kz": 1,
  "upaas.kazteleport.kz": 1,
  "cloudjiffy.net": 1,
  "fra1-de.cloudjiffy.net": 1,
  "west1-us.cloudjiffy.net": 1,
  "jls-sto1.elastx.net": 1,
  "jls-sto2.elastx.net": 1,
  "jls-sto3.elastx.net": 1,
  "faststacks.net": 1,
  "fr-1.paas.massivegrid.net": 1,
  "lon-1.paas.massivegrid.net": 1,
  "lon-2.paas.massivegrid.net": 1,
  "ny-1.paas.massivegrid.net": 1,
  "ny-2.paas.massivegrid.net": 1,
  "sg-1.paas.massivegrid.net": 1,
  "jelastic.saveincloud.net": 1,
  "nordeste-idc.saveincloud.net": 1,
  "j.scaleforce.net": 1,
  "jelastic.tsukaeru.net": 1,
  "sdscloud.pl": 1,
  "unicloud.pl": 1,
  "mircloud.ru": 1,
  "jelastic.regruhosting.ru": 1,
  "enscaled.sg": 1,
  "jele.site": 1,
  "jelastic.team": 1,
  "orangecloud.tn": 1,
  "j.layershift.co.uk": 1,
  "phx.enscaled.us": 1,
  "mircloud.us": 1,
  "myjino.ru": 1,
  "hosting.myjino.ru": 2,
  "landing.myjino.ru": 2,
  "spectrum.myjino.ru": 2,
  "vps.myjino.ru": 2,
  "jotelulu.cloud": 1,
  "triton.zone": 2,
  "cns.joyent.com": 2,
  "js.org": 1,
  "kaas.gg": 1,
  "khplay.nl": 1,
  "ktistory.com": 1,
  "kapsi.fi": 1,
  "keymachine.de": 1,
  "kinghost.net": 1,
  "uni5.net": 1,
  "knightpoint.systems": 1,
  "koobin.events": 1,
  "oya.to": 1,
  "kuleuven.cloud": 1,
  "ezproxy.kuleuven.be": 1,
  "co.krd": 1,
  "edu.krd": 1,
  "krellian.net": 1,
  "webthings.io": 1,
  "git-repos.de": 1,
  "lcube-server.de": 1,
  "svn-repos.de": 1,
  "leadpages.co": 1,
  "lpages.co": 1,
  "lpusercontent.com": 1,
  "lelux.site": 1,
  "co.business": 1,
  "co.education": 1,
  "co.events": 1,
  "co.financial": 1,
  "co.network": 1,
  "co.place": 1,
  "co.technology": 1,
  "app.lmpm.com": 1,
  "linkyard.cloud": 1,
  "linkyard-cloud.ch": 1,
  "members.linode.com": 1,
  "nodebalancer.linode.com": 2,
  "linodeobjects.com": 2,
  "ip.linodeusercontent.com": 1,
  "we.bs": 1,
  "user.localcert.dev": 2,
  "localzone.xyz": 1,
  "loginline.app": 1,
  "loginline.dev": 1,
  "loginline.io": 1,
  "loginline.services": 1,
  "loginline.site": 1,
  "servers.run": 1,
  "lohmus.me": 1,
  "krasnik.pl": 1,
  "leczna.pl": 1,
  "lubartow.pl": 1,
  "lublin.pl": 1,
  "poniatowa.pl": 1,
  "swidnik.pl": 1,
  "glug.org.uk": 1,
  "lug.org.uk": 1,
  "lugs.org.uk": 1,
  "barsy.bg": 1,
  "barsy.co.uk": 1,
  "barsyonline.co.uk": 1,
  "barsycenter.com": 1,
  "barsyonline.com": 1,
  "barsy.club": 1,
  "barsy.de": 1,
  "barsy.eu": 1,
  "barsy.in": 1,
  "barsy.info": 1,
  "barsy.io": 1,
  "barsy.me": 1,
  "barsy.menu": 1,
  "barsy.mobi": 1,
  "barsy.net": 1,
  "barsy.online": 1,
  "barsy.org": 1,
  "barsy.pro": 1,
  "barsy.pub": 1,
  "barsy.ro": 1,
  "barsy.shop": 1,
  "barsy.site": 1,
  "barsy.support": 1,
  "barsy.uk": 1,
  "magentosite.cloud": 2,
  "mayfirst.info": 1,
  "mayfirst.org": 1,
  "hb.cldmail.ru": 1,
  "cn.vu": 1,
  "mazeplay.com": 1,
  "mcpe.me": 1,
  "mcdir.me": 1,
  "mcdir.ru": 1,
  "mcpre.ru": 1,
  "vps.mcdir.ru": 1,
  "mediatech.by": 1,
  "mediatech.dev": 1,
  "hra.health": 1,
  "miniserver.com": 1,
  "memset.net": 1,
  "messerli.app": 1,
  "cloud.metacentrum.cz": 2,
  "custom.metacentrum.cz": 1,
  "flt.cloud.muni.cz": 1,
  "usr.cloud.muni.cz": 1,
  "meteorapp.com": 1,
  "eu.meteorapp.com": 1,
  "co.pl": 1,
  "azurecontainer.io": 2,
  "azurewebsites.net": 1,
  "azure-mobile.net": 1,
  "cloudapp.net": 1,
  "azurestaticapps.net": 1,
  "1.azurestaticapps.net": 1,
  "2.azurestaticapps.net": 1,
  "3.azurestaticapps.net": 1,
  "4.azurestaticapps.net": 1,
  "5.azurestaticapps.net": 1,
  "6.azurestaticapps.net": 1,
  "7.azurestaticapps.net": 1,
  "centralus.azurestaticapps.net": 1,
  "eastasia.azurestaticapps.net": 1,
  "eastus2.azurestaticapps.net": 1,
  "westeurope.azurestaticapps.net": 1,
  "westus2.azurestaticapps.net": 1,
  "csx.cc": 1,
  "mintere.site": 1,
  "forte.id": 1,
  "mozilla-iot.org": 1,
  "bmoattachments.org": 1,
  "net.ru": 1,
  "org.ru": 1,
  "pp.ru": 1,
  "hostedpi.com": 1,
  "customer.mythic-beasts.com": 1,
  "caracal.mythic-beasts.com": 1,
  "fentiger.mythic-beasts.com": 1,
  "lynx.mythic-beasts.com": 1,
  "ocelot.mythic-beasts.com": 1,
  "oncilla.mythic-beasts.com": 1,
  "onza.mythic-beasts.com": 1,
  "sphinx.mythic-beasts.com": 1,
  "vs.mythic-beasts.com": 1,
  "x.mythic-beasts.com": 1,
  "yali.mythic-beasts.com": 1,
  "cust.retrosnub.co.uk": 1,
  "ui.nabu.casa": 1,
  "cloud.nospamproxy.com": 1,
  "netlify.app": 1,
  "4u.com": 1,
  "ngrok.app": 1,
  "ngrok-free.app": 1,
  "ngrok.dev": 1,
  "ngrok-free.dev": 1,
  "ngrok.io": 1,
  "ap.ngrok.io": 1,
  "au.ngrok.io": 1,
  "eu.ngrok.io": 1,
  "in.ngrok.io": 1,
  "jp.ngrok.io": 1,
  "sa.ngrok.io": 1,
  "us.ngrok.io": 1,
  "ngrok.pizza": 1,
  "torun.pl": 1,
  "nh-serv.co.uk": 1,
  "nfshost.com": 1,
  "developer.app": 2,
  "noop.app": 1,
  "northflank.app": 2,
  "build.run": 2,
  "code.run": 2,
  "database.run": 2,
  "migration.run": 2,
  "noticeable.news": 1,
  "dnsking.ch": 1,
  "mypi.co": 1,
  "n4t.co": 1,
  "001www.com": 1,
  "ddnslive.com": 1,
  "myiphost.com": 1,
  "forumz.info": 1,
  "16-b.it": 1,
  "32-b.it": 1,
  "64-b.it": 1,
  "soundcast.me": 1,
  "tcp4.me": 1,
  "dnsup.net": 1,
  "hicam.net": 1,
  "now-dns.net": 1,
  "ownip.net": 1,
  "vpndns.net": 1,
  "dynserv.org": 1,
  "now-dns.org": 1,
  "x443.pw": 1,
  "now-dns.top": 1,
  "ntdll.top": 1,
  "freeddns.us": 1,
  "crafting.xyz": 1,
  "zapto.xyz": 1,
  "nsupdate.info": 1,
  "nerdpol.ovh": 1,
  "blogsyte.com": 1,
  "brasilia.me": 1,
  "cable-modem.org": 1,
  "ciscofreak.com": 1,
  "collegefan.org": 1,
  "couchpotatofries.org": 1,
  "damnserver.com": 1,
  "ddns.me": 1,
  "ditchyourip.com": 1,
  "dnsfor.me": 1,
  "dnsiskinky.com": 1,
  "dvrcam.info": 1,
  "dynns.com": 1,
  "eating-organic.net": 1,
  "fantasyleague.cc": 1,
  "geekgalaxy.com": 1,
  "golffan.us": 1,
  "health-carereform.com": 1,
  "homesecuritymac.com": 1,
  "homesecuritypc.com": 1,
  "hopto.me": 1,
  "ilovecollege.info": 1,
  "loginto.me": 1,
  "mlbfan.org": 1,
  "mmafan.biz": 1,
  "myactivedirectory.com": 1,
  "mydissent.net": 1,
  "myeffect.net": 1,
  "mymediapc.net": 1,
  "mypsx.net": 1,
  "mysecuritycamera.com": 1,
  "mysecuritycamera.net": 1,
  "mysecuritycamera.org": 1,
  "net-freaks.com": 1,
  "nflfan.org": 1,
  "nhlfan.net": 1,
  "no-ip.ca": 1,
  "no-ip.co.uk": 1,
  "no-ip.net": 1,
  "noip.us": 1,
  "onthewifi.com": 1,
  "pgafan.net": 1,
  "point2this.com": 1,
  "pointto.us": 1,
  "privatizehealthinsurance.net": 1,
  "quicksytes.com": 1,
  "read-books.org": 1,
  "securitytactics.com": 1,
  "serveexchange.com": 1,
  "servehumour.com": 1,
  "servep2p.com": 1,
  "servesarcasm.com": 1,
  "stufftoread.com": 1,
  "ufcfan.org": 1,
  "unusualperson.com": 1,
  "workisboring.com": 1,
  "3utilities.com": 1,
  "bounceme.net": 1,
  "ddns.net": 1,
  "ddnsking.com": 1,
  "gotdns.ch": 1,
  "hopto.org": 1,
  "myftp.biz": 1,
  "myftp.org": 1,
  "myvnc.com": 1,
  "no-ip.biz": 1,
  "no-ip.info": 1,
  "no-ip.org": 1,
  "noip.me": 1,
  "redirectme.net": 1,
  "servebeer.com": 1,
  "serveblog.net": 1,
  "servecounterstrike.com": 1,
  "serveftp.com": 1,
  "servegame.com": 1,
  "servehalflife.com": 1,
  "servehttp.com": 1,
  "serveirc.com": 1,
  "serveminecraft.net": 1,
  "servemp3.com": 1,
  "servepics.com": 1,
  "servequake.com": 1,
  "sytes.net": 1,
  "webhop.me": 1,
  "zapto.org": 1,
  "stage.nodeart.io": 1,
  "pcloud.host": 1,
  "nyc.mn": 1,
  "static.observableusercontent.com": 1,
  "cya.gg": 1,
  "omg.lol": 1,
  "cloudycluster.net": 1,
  "omniwe.site": 1,
  "123hjemmeside.dk": 1,
  "123hjemmeside.no": 1,
  "123homepage.it": 1,
  "123kotisivu.fi": 1,
  "123minsida.se": 1,
  "123miweb.es": 1,
  "123paginaweb.pt": 1,
  "123sait.ru": 1,
  "123siteweb.fr": 1,
  "123webseite.at": 1,
  "123webseite.de": 1,
  "123website.be": 1,
  "123website.ch": 1,
  "123website.lu": 1,
  "123website.nl": 1,
  "service.one": 1,
  "simplesite.com": 1,
  "simplesite.com.br": 1,
  "simplesite.gr": 1,
  "simplesite.pl": 1,
  "nid.io": 1,
  "opensocial.site": 1,
  "opencraft.hosting": 1,
  "orsites.com": 1,
  "operaunite.com": 1,
  "tech.orange": 1,
  "authgear-staging.com": 1,
  "authgearapps.com": 1,
  "skygearapp.com": 1,
  "outsystemscloud.com": 1,
  "webpaas.ovh.net": 2,
  "hosting.ovh.net": 2,
  "ownprovider.com": 1,
  "own.pm": 1,
  "owo.codes": 2,
  "ox.rs": 1,
  "oy.lc": 1,
  "pgfog.com": 1,
  "pagefrontapp.com": 1,
  "pagexl.com": 1,
  "paywhirl.com": 2,
  "bar0.net": 1,
  "bar1.net": 1,
  "bar2.net": 1,
  "rdv.to": 1,
  "art.pl": 1,
  "gliwice.pl": 1,
  "krakow.pl": 1,
  "poznan.pl": 1,
  "wroc.pl": 1,
  "zakopane.pl": 1,
  "pantheonsite.io": 1,
  "gotpantheon.com": 1,
  "mypep.link": 1,
  "perspecta.cloud": 1,
  "lk3.ru": 1,
  "on-web.fr": 1,
  "bc.platform.sh": 1,
  "ent.platform.sh": 1,
  "eu.platform.sh": 1,
  "us.platform.sh": 1,
  "platformsh.site": 2,
  "tst.site": 2,
  "platter-app.com": 1,
  "platter-app.dev": 1,
  "platterp.us": 1,
  "pdns.page": 1,
  "plesk.page": 1,
  "pleskns.com": 1,
  "dyn53.io": 1,
  "onporter.run": 1,
  "co.bn": 1,
  "postman-echo.com": 1,
  "pstmn.io": 1,
  "mock.pstmn.io": 1,
  "httpbin.org": 1,
  "prequalifyme.today": 1,
  "xen.prgmr.com": 1,
  "priv.at": 1,
  "prvcy.page": 1,
  "dweb.link": 2,
  "protonet.io": 1,
  "chirurgiens-dentistes-en-france.fr": 1,
  "byen.site": 1,
  "pubtls.org": 1,
  "pythonanywhere.com": 1,
  "eu.pythonanywhere.com": 1,
  "qoto.io": 1,
  "qualifioapp.com": 1,
  "ladesk.com": 1,
  "qbuser.com": 1,
  "cloudsite.builders": 1,
  "instances.spawn.cc": 1,
  "instantcloud.cn": 1,
  "ras.ru": 1,
  "qa2.com": 1,
  "qcx.io": 1,
  "sys.qcx.io": 2,
  "dev-myqnapcloud.com": 1,
  "alpha-myqnapcloud.com": 1,
  "myqnapcloud.com": 1,
  "quipelements.com": 2,
  "vapor.cloud": 1,
  "vaporcloud.io": 1,
  "rackmaze.com": 1,
  "rackmaze.net": 1,
  "g.vbrplsbx.io": 1,
  "on-k3s.io": 2,
  "on-rancher.cloud": 2,
  "on-rio.io": 2,
  "readthedocs.io": 1,
  "rhcloud.com": 1,
  "app.render.com": 1,
  "onrender.com": 1,
  "firewalledreplit.co": 1,
  "id.firewalledreplit.co": 1,
  "repl.co": 1,
  "id.repl.co": 1,
  "repl.run": 1,
  "resindevice.io": 1,
  "devices.resinstaging.io": 1,
  "hzc.io": 1,
  "wellbeingzone.eu": 1,
  "wellbeingzone.co.uk": 1,
  "adimo.co.uk": 1,
  "itcouldbewor.se": 1,
  "git-pages.rit.edu": 1,
  "rocky.page": 1,
  "xn--90amc.xn--p1acf": 1,
  "xn--j1aef.xn--p1acf": 1,
  "xn--j1ael8b.xn--p1acf": 1,
  "xn--h1ahn.xn--p1acf": 1,
  "xn--j1adp.xn--p1acf": 1,
  "xn--c1avg.xn--p1acf": 1,
  "xn--80aaa0cvac.xn--p1acf": 1,
  "xn--h1aliz.xn--p1acf": 1,
  "xn--90a1af.xn--p1acf": 1,
  "xn--41a.xn--p1acf": 1,
  "180r.com": 1,
  "dojin.com": 1,
  "sakuratan.com": 1,
  "sakuraweb.com": 1,
  "x0.com": 1,
  "2-d.jp": 1,
  "bona.jp": 1,
  "crap.jp": 1,
  "daynight.jp": 1,
  "eek.jp": 1,
  "flop.jp": 1,
  "halfmoon.jp": 1,
  "jeez.jp": 1,
  "matrix.jp": 1,
  "mimoza.jp": 1,
  "ivory.ne.jp": 1,
  "mail-box.ne.jp": 1,
  "mints.ne.jp": 1,
  "mokuren.ne.jp": 1,
  "opal.ne.jp": 1,
  "sakura.ne.jp": 1,
  "sumomo.ne.jp": 1,
  "topaz.ne.jp": 1,
  "netgamers.jp": 1,
  "nyanta.jp": 1,
  "o0o0.jp": 1,
  "rdy.jp": 1,
  "rgr.jp": 1,
  "rulez.jp": 1,
  "s3.isk01.sakurastorage.jp": 1,
  "s3.isk02.sakurastorage.jp": 1,
  "saloon.jp": 1,
  "sblo.jp": 1,
  "skr.jp": 1,
  "tank.jp": 1,
  "uh-oh.jp": 1,
  "undo.jp": 1,
  "rs.webaccel.jp": 1,
  "user.webaccel.jp": 1,
  "websozai.jp": 1,
  "xii.jp": 1,
  "squares.net": 1,
  "jpn.org": 1,
  "kirara.st": 1,
  "x0.to": 1,
  "from.tv": 1,
  "sakura.tv": 1,
  "builder.code.com": 2,
  "dev-builder.code.com": 2,
  "stg-builder.code.com": 2,
  "sandcats.io": 1,
  "logoip.de": 1,
  "logoip.com": 1,
  "fr-par-1.baremetal.scw.cloud": 1,
  "fr-par-2.baremetal.scw.cloud": 1,
  "nl-ams-1.baremetal.scw.cloud": 1,
  "fnc.fr-par.scw.cloud": 1,
  "functions.fnc.fr-par.scw.cloud": 1,
  "k8s.fr-par.scw.cloud": 1,
  "nodes.k8s.fr-par.scw.cloud": 1,
  "s3.fr-par.scw.cloud": 1,
  "s3-website.fr-par.scw.cloud": 1,
  "whm.fr-par.scw.cloud": 1,
  "priv.instances.scw.cloud": 1,
  "pub.instances.scw.cloud": 1,
  "k8s.scw.cloud": 1,
  "k8s.nl-ams.scw.cloud": 1,
  "nodes.k8s.nl-ams.scw.cloud": 1,
  "s3.nl-ams.scw.cloud": 1,
  "s3-website.nl-ams.scw.cloud": 1,
  "whm.nl-ams.scw.cloud": 1,
  "k8s.pl-waw.scw.cloud": 1,
  "nodes.k8s.pl-waw.scw.cloud": 1,
  "s3.pl-waw.scw.cloud": 1,
  "s3-website.pl-waw.scw.cloud": 1,
  "scalebook.scw.cloud": 1,
  "smartlabeling.scw.cloud": 1,
  "dedibox.fr": 1,
  "schokokeks.net": 1,
  "gov.scot": 1,
  "service.gov.scot": 1,
  "scrysec.com": 1,
  "firewall-gateway.com": 1,
  "firewall-gateway.de": 1,
  "my-gateway.de": 1,
  "my-router.de": 1,
  "spdns.de": 1,
  "spdns.eu": 1,
  "firewall-gateway.net": 1,
  "my-firewall.org": 1,
  "myfirewall.org": 1,
  "spdns.org": 1,
  "seidat.net": 1,
  "sellfy.store": 1,
  "senseering.net": 1,
  "minisite.ms": 1,
  "magnet.page": 1,
  "biz.ua": 1,
  "co.ua": 1,
  "pp.ua": 1,
  "shiftcrypto.dev": 1,
  "shiftcrypto.io": 1,
  "shiftedit.io": 1,
  "myshopblocks.com": 1,
  "myshopify.com": 1,
  "shopitsite.com": 1,
  "shopware.store": 1,
  "mo-siemens.io": 1,
  "1kapp.com": 1,
  "appchizi.com": 1,
  "applinzi.com": 1,
  "sinaapp.com": 1,
  "vipsinaapp.com": 1,
  "siteleaf.net": 1,
  "bounty-full.com": 1,
  "alpha.bounty-full.com": 1,
  "beta.bounty-full.com": 1,
  "aeroport.fr": 1,
  "avocat.fr": 1,
  "chambagri.fr": 1,
  "chirurgiens-dentistes.fr": 1,
  "experts-comptables.fr": 1,
  "medecin.fr": 1,
  "notaires.fr": 1,
  "pharmacien.fr": 1,
  "port.fr": 1,
  "veterinaire.fr": 1,
  "small-web.org": 1,
  "vp4.me": 1,
  "snowflake.app": 1,
  "privatelink.snowflake.app": 1,
  "streamlit.app": 1,
  "streamlitapp.com": 1,
  "try-snowplow.com": 1,
  "srht.site": 1,
  "stackhero-network.com": 1,
  "musician.io": 1,
  "novecore.site": 1,
  "static.land": 1,
  "dev.static.land": 1,
  "sites.static.land": 1,
  "storebase.store": 1,
  "vps-host.net": 1,
  "atl.jelastic.vps-host.net": 1,
  "njs.jelastic.vps-host.net": 1,
  "ric.jelastic.vps-host.net": 1,
  "playstation-cloud.com": 1,
  "apps.lair.io": 1,
  "stolos.io": 2,
  "spacekit.io": 1,
  "customer.speedpartner.de": 1,
  "myspreadshop.at": 1,
  "myspreadshop.com.au": 1,
  "myspreadshop.be": 1,
  "myspreadshop.ca": 1,
  "myspreadshop.ch": 1,
  "myspreadshop.com": 1,
  "myspreadshop.de": 1,
  "myspreadshop.dk": 1,
  "myspreadshop.es": 1,
  "myspreadshop.fi": 1,
  "myspreadshop.fr": 1,
  "myspreadshop.ie": 1,
  "myspreadshop.it": 1,
  "myspreadshop.net": 1,
  "myspreadshop.nl": 1,
  "myspreadshop.no": 1,
  "myspreadshop.pl": 1,
  "myspreadshop.se": 1,
  "myspreadshop.co.uk": 1,
  "api.stdlib.com": 1,
  "storipress.app": 1,
  "storj.farm": 1,
  "utwente.io": 1,
  "soc.srcf.net": 1,
  "user.srcf.net": 1,
  "temp-dns.com": 1,
  "supabase.co": 1,
  "supabase.in": 1,
  "supabase.net": 1,
  "su.paba.se": 1,
  "s5y.io": 2,
  "sensiosite.cloud": 2,
  "syncloud.it": 1,
  "dscloud.biz": 1,
  "direct.quickconnect.cn": 1,
  "dsmynas.com": 1,
  "familyds.com": 1,
  "diskstation.me": 1,
  "dscloud.me": 1,
  "i234.me": 1,
  "myds.me": 1,
  "synology.me": 1,
  "dscloud.mobi": 1,
  "dsmynas.net": 1,
  "familyds.net": 1,
  "dsmynas.org": 1,
  "familyds.org": 1,
  "vpnplus.to": 1,
  "direct.quickconnect.to": 1,
  "tabitorder.co.il": 1,
  "mytabit.co.il": 1,
  "mytabit.com": 1,
  "taifun-dns.de": 1,
  "beta.tailscale.net": 1,
  "ts.net": 1,
  "gda.pl": 1,
  "gdansk.pl": 1,
  "gdynia.pl": 1,
  "med.pl": 1,
  "sopot.pl": 1,
  "site.tb-hosting.com": 1,
  "edugit.io": 1,
  "s3.teckids.org": 1,
  "telebit.app": 1,
  "telebit.io": 1,
  "telebit.xyz": 2,
  "firenet.ch": 2,
  "svc.firenet.ch": 2,
  "reservd.com": 1,
  "thingdustdata.com": 1,
  "cust.dev.thingdust.io": 1,
  "cust.disrec.thingdust.io": 1,
  "cust.prod.thingdust.io": 1,
  "cust.testing.thingdust.io": 1,
  "reservd.dev.thingdust.io": 1,
  "reservd.disrec.thingdust.io": 1,
  "reservd.testing.thingdust.io": 1,
  "tickets.io": 1,
  "arvo.network": 1,
  "azimuth.network": 1,
  "tlon.network": 1,
  "torproject.net": 1,
  "pages.torproject.net": 1,
  "bloxcms.com": 1,
  "townnews-staging.com": 1,
  "12hp.at": 1,
  "2ix.at": 1,
  "4lima.at": 1,
  "lima-city.at": 1,
  "12hp.ch": 1,
  "2ix.ch": 1,
  "4lima.ch": 1,
  "lima-city.ch": 1,
  "trafficplex.cloud": 1,
  "de.cool": 1,
  "12hp.de": 1,
  "2ix.de": 1,
  "4lima.de": 1,
  "lima-city.de": 1,
  "1337.pictures": 1,
  "clan.rip": 1,
  "lima-city.rocks": 1,
  "webspace.rocks": 1,
  "lima.zone": 1,
  "transurl.be": 2,
  "transurl.eu": 2,
  "transurl.nl": 2,
  "site.transip.me": 1,
  "tuxfamily.org": 1,
  "dd-dns.de": 1,
  "diskstation.eu": 1,
  "diskstation.org": 1,
  "dray-dns.de": 1,
  "draydns.de": 1,
  "dyn-vpn.de": 1,
  "dynvpn.de": 1,
  "mein-vigor.de": 1,
  "my-vigor.de": 1,
  "my-wan.de": 1,
  "syno-ds.de": 1,
  "synology-diskstation.de": 1,
  "synology-ds.de": 1,
  "typedream.app": 1,
  "pro.typeform.com": 1,
  "uber.space": 1,
  "uberspace.de": 2,
  "hk.com": 1,
  "hk.org": 1,
  "ltd.hk": 1,
  "inc.hk": 1,
  "it.com": 1,
  "name.pm": 1,
  "sch.tf": 1,
  "biz.wf": 1,
  "sch.wf": 1,
  "org.yt": 1,
  "virtualuser.de": 1,
  "virtual-user.de": 1,
  "upli.io": 1,
  "urown.cloud": 1,
  "dnsupdate.info": 1,
  "lib.de.us": 1,
  "2038.io": 1,
  "vercel.app": 1,
  "vercel.dev": 1,
  "now.sh": 1,
  "router.management": 1,
  "v-info.info": 1,
  "voorloper.cloud": 1,
  "neko.am": 1,
  "nyaa.am": 1,
  "be.ax": 1,
  "cat.ax": 1,
  "es.ax": 1,
  "eu.ax": 1,
  "gg.ax": 1,
  "mc.ax": 1,
  "us.ax": 1,
  "xy.ax": 1,
  "nl.ci": 1,
  "xx.gl": 1,
  "app.gp": 1,
  "blog.gt": 1,
  "de.gt": 1,
  "to.gt": 1,
  "be.gy": 1,
  "cc.hn": 1,
  "blog.kg": 1,
  "io.kg": 1,
  "jp.kg": 1,
  "tv.kg": 1,
  "uk.kg": 1,
  "us.kg": 1,
  "de.ls": 1,
  "at.md": 1,
  "de.md": 1,
  "jp.md": 1,
  "to.md": 1,
  "indie.porn": 1,
  "vxl.sh": 1,
  "ch.tc": 1,
  "me.tc": 1,
  "we.tc": 1,
  "nyan.to": 1,
  "at.vg": 1,
  "blog.vu": 1,
  "dev.vu": 1,
  "me.vu": 1,
  "v.ua": 1,
  "vultrobjects.com": 2,
  "wafflecell.com": 1,
  "webhare.dev": 2,
  "reserve-online.net": 1,
  "reserve-online.com": 1,
  "bookonline.app": 1,
  "hotelwithflight.com": 1,
  "wedeploy.io": 1,
  "wedeploy.me": 1,
  "wedeploy.sh": 1,
  "remotewd.com": 1,
  "pages.wiardweb.com": 1,
  "wmflabs.org": 1,
  "toolforge.org": 1,
  "wmcloud.org": 1,
  "panel.gg": 1,
  "daemon.panel.gg": 1,
  "messwithdns.com": 1,
  "woltlab-demo.com": 1,
  "myforum.community": 1,
  "community-pro.de": 1,
  "diskussionsbereich.de": 1,
  "community-pro.net": 1,
  "meinforum.net": 1,
  "affinitylottery.org.uk": 1,
  "raffleentry.org.uk": 1,
  "weeklylottery.org.uk": 1,
  "wpenginepowered.com": 1,
  "js.wpenginepowered.com": 1,
  "wixsite.com": 1,
  "editorx.io": 1,
  "wixstudio.io": 1,
  "wix.run": 1,
  "half.host": 1,
  "xnbay.com": 1,
  "u2.xnbay.com": 1,
  "u2-local.xnbay.com": 1,
  "cistron.nl": 1,
  "demon.nl": 1,
  "xs4all.space": 1,
  "yandexcloud.net": 1,
  "storage.yandexcloud.net": 1,
  "website.yandexcloud.net": 1,
  "official.academy": 1,
  "yolasite.com": 1,
  "ybo.faith": 1,
  "yombo.me": 1,
  "homelink.one": 1,
  "ybo.party": 1,
  "ybo.review": 1,
  "ybo.science": 1,
  "ybo.trade": 1,
  "ynh.fr": 1,
  "nohost.me": 1,
  "noho.st": 1,
  "za.net": 1,
  "za.org": 1,
  "bss.design": 1,
  "basicserver.io": 1,
  "virtualserver.io": 1,
  "enterprisecloud.nu": 1
}